interface Props {
  active?: boolean
  width?: number
  height?: number
}
export const BookMark = () => {
  return (
    <svg
      width={24}
      height={33}
      viewBox='0 0 24 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.5 15H16.5M7.5 21H16.5M7.5 9H16.5M1.5 3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H21C21.3978 1.5 21.7794 1.65804 22.0607 1.93934C22.342 2.22064 22.5 2.60218 22.5 3V31.5L17.25 27.75L12 31.5L6.75 27.75L1.5 31.5V3Z'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Polygon = () => {
  return (
    <svg
      className='ml-[15px] border border-grey-100 shadow-none outline-none'
      width='22'
      height='22'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16 10L12 14L8 10'
        stroke='#161616'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}
export const Eye = () => {
  return (
    <svg
      width={15}
      height={16}
      viewBox='0 0 15 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.9047 7.5553C14.7707 7.37199 11.5778 3.06683 7.49993 3.06683C3.42206 3.06683 0.229043 7.37199 0.0951857 7.55512C-0.0317286 7.72903 -0.0317286 7.9649 0.0951857 8.13881C0.229043 8.32212 3.42206 12.6273 7.49993 12.6273C11.5778 12.6273 14.7707 8.32209 14.9047 8.13895C15.0318 7.96508 15.0318 7.72903 14.9047 7.5553ZM7.49993 11.6383C4.49614 11.6383 1.89454 8.78085 1.12442 7.84672C1.89355 6.91176 4.4897 4.05584 7.49993 4.05584C10.5036 4.05584 13.105 6.91276 13.8754 7.84739C13.1063 8.78231 10.5102 11.6383 7.49993 11.6383Z'
        fill='#828282'
      />
      <path
        d='M7.50001 4.88C5.86401 4.88 4.53296 6.21105 4.53296 7.84705C4.53296 9.48305 5.86401 10.8141 7.50001 10.8141C9.136 10.8141 10.4671 9.48305 10.4671 7.84705C10.4671 6.21105 9.136 4.88 7.50001 4.88ZM7.50001 9.82506C6.40928 9.82506 5.52199 8.93775 5.52199 7.84705C5.52199 6.75636 6.40931 5.86904 7.50001 5.86904C8.5907 5.86904 9.47802 6.75636 9.47802 7.84705C9.47802 8.93775 8.59073 9.82506 7.50001 9.82506Z'
        fill='#828282'
      />
    </svg>
  )
}
export const Clock = () => {
  return (
    <svg
      width={13}
      height={14}
      viewBox='0 0 13 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3945_7694)'>
        <path
          d='M8.81613 7.70994L7.00357 6.35053V3.58138C7.00357 3.30294 6.77851 3.07788 6.50008 3.07788C6.22164 3.07788 5.99658 3.30294 5.99658 3.58138V6.6023C5.99658 6.76089 6.0711 6.91044 6.19798 7.0051L8.21191 8.51556C8.30253 8.58353 8.40828 8.61626 8.5135 8.61626C8.66707 8.61626 8.81811 8.54728 8.91681 8.41436C9.08401 8.19229 9.03868 7.87661 8.81613 7.70994Z'
          fill='#828282'
        />
        <path
          d='M6.5 0.0620117C2.91568 0.0620117 0 2.97769 0 6.56201C0 10.1463 2.91568 13.062 6.5 13.062C10.0843 13.062 13 10.1463 13 6.56201C13 2.97769 10.0843 0.0620117 6.5 0.0620117ZM6.5 12.055C3.47153 12.055 1.00697 9.59048 1.00697 6.56201C1.00697 3.53354 3.47153 1.06898 6.5 1.06898C9.52897 1.06898 11.993 3.53354 11.993 6.56201C11.993 9.59048 9.52847 12.055 6.5 12.055Z'
          fill='#828282'
        />
      </g>
      <defs>
        <clipPath id='clip0_3945_7694'>
          <rect
            width={13}
            height={13}
            fill='white'
            transform='translate(0 0.0620117)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const HomeBoldDark = () => {
  return (
    <svg
      width={24}
      height={25}
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_3984_34484)'>
        <path
          d='M23.3529 11.0521C23.3524 11.0516 23.3518 11.051 23.3513 11.0505L13.5612 1.26074C13.1439 0.843262 12.5891 0.613281 11.9989 0.613281C11.4088 0.613281 10.854 0.843079 10.4365 1.26056L0.651514 11.0453C0.648218 11.0486 0.644922 11.0521 0.641626 11.0554C-0.215307 11.9173 -0.213843 13.3157 0.645838 14.1754C1.0386 14.5683 1.55734 14.7959 2.11196 14.8197C2.13449 14.8219 2.15719 14.823 2.18008 14.823H2.57028V22.0276C2.57028 23.4533 3.73025 24.6133 5.15627 24.6133H8.98647C9.37466 24.6133 9.6896 24.2985 9.6896 23.9102V18.2617C9.6896 17.6111 10.2188 17.082 10.8693 17.082H13.1285C13.7791 17.082 14.3083 17.6111 14.3083 18.2617V23.9102C14.3083 24.2985 14.623 24.6133 15.0114 24.6133H18.8416C20.2676 24.6133 21.4276 23.4533 21.4276 22.0276V14.823H21.7894C22.3794 14.823 22.9342 14.5932 23.3518 14.1757C24.2124 13.3146 24.2128 11.9138 23.3529 11.0521Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_3984_34484'>
          <rect
            width={24}
            height={24}
            fill='white'
            transform='translate(0 0.613281)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconBack = () => {
  return (
    <svg
      width={12}
      height={20}
      viewBox='0 0 12 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 2.91414L9.7166 0.681641L0 10.1816L9.7166 19.6816L12 17.4491L4.583 10.1816L12 2.91414Z'
        fill='#555555'
      />
    </svg>
  )
}
export const Bep = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1_10101)'>
        <path
          d='M23 8H19'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M16 23H4C2.343 23 1 21.657 1 20V8H19V20C19 21.657 17.657 23 16 23Z'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M1 13H19'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M10 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M5 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
        <path
          d='M15 4V1'
          stroke='#212121'
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap='square'
        />
      </g>
      <defs>
        <clipPath id='clip0_1_10101'>
          <rect width={24} height={24} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const RuaBat = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 2H1V23H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 20C9.65685 20 11 18.6569 11 17C11 15.3431 9.65685 14 8 14C6.34315 14 5 15.3431 5 17C5 18.6569 6.34315 20 8 20Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 6H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 10H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 15H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 19H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconHome = () => {
  return (
    <svg
      width={23}
      height={24}
      viewBox='0 0 23 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.2787 23.6788H6.72043C5.6395 23.719 4.5864 23.3309 3.78994 22.5991C2.99348 21.8672 2.51801 20.8506 2.46683 19.7701V14.6461C2.46683 14.4283 2.55335 14.2194 2.70734 14.0654C2.86134 13.9114 3.0702 13.8249 3.28799 13.8249C3.50577 13.8249 3.71464 13.9114 3.86864 14.0654C4.02263 14.2194 4.10915 14.4283 4.10915 14.6461V19.7701C4.15962 20.4151 4.46178 21.0143 4.95037 21.4384C5.43896 21.8624 6.07476 22.0773 6.72043 22.0365H16.2787C16.9244 22.0773 17.5602 21.8624 18.0488 21.4384C18.5373 21.0143 18.8395 20.4151 18.89 19.7701V14.6461C18.89 14.4283 18.9765 14.2194 19.1305 14.0654C19.2845 13.9114 19.4934 13.8249 19.7111 13.8249C19.9289 13.8249 20.1378 13.9114 20.2918 14.0654C20.4458 14.2194 20.5323 14.4283 20.5323 14.6461V19.7701C20.4811 20.8506 20.0056 21.8672 19.2092 22.5991C18.4127 23.3309 17.3596 23.719 16.2787 23.6788ZM22.7576 12.7656C22.8346 12.6893 22.8957 12.5985 22.9374 12.4984C22.9791 12.3983 23.0005 12.291 23.0005 12.1826C23.0005 12.0742 22.9791 11.9669 22.9374 11.8668C22.8957 11.7667 22.8346 11.6759 22.7576 11.5996L12.0826 0.924538C12.0062 0.847572 11.9154 0.786482 11.8154 0.744793C11.7153 0.703104 11.608 0.681641 11.4996 0.681641C11.3912 0.681641 11.2838 0.703104 11.1838 0.744793C11.0837 0.786482 10.9929 0.847572 10.9165 0.924538L0.241495 11.5996C0.0868685 11.7542 0 11.9639 0 12.1826C0 12.4013 0.0868685 12.611 0.241495 12.7656C0.396122 12.9203 0.605842 13.0071 0.824517 13.0071C1.04319 13.0071 1.25291 12.9203 1.40754 12.7656L11.4996 2.66539L21.5916 12.7656C21.6679 12.8426 21.7587 12.9037 21.8588 12.9454C21.9589 12.9871 22.0662 13.0085 22.1746 13.0085C22.283 13.0085 22.3903 12.9871 22.4904 12.9454C22.5905 12.9037 22.6813 12.8426 22.7576 12.7656Z'
        fill='#282828'
      />
    </svg>
  )
}
export const LogoIonah = () => {
  return (
    <svg
      width={127}
      height={36}
      viewBox='0 0 127 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.25505 36.4934C1.96394 36.4934 0.0957031 34.6311 0.0957031 32.3473V14.5675C0.0957031 12.2837 1.96394 10.4214 4.25505 10.4214C6.54616 10.4214 8.41439 12.2837 8.41439 14.5675V32.3473C8.41439 34.6311 6.54616 36.4934 4.25505 36.4934Z'
        fill='black'
      />
      <path
        d='M122.744 36.4935C120.452 36.4935 118.584 34.6312 118.584 32.3474V23.2248C118.584 21.828 118.105 20.5383 117.227 19.6072C116.186 18.4936 114.949 17.9525 113.447 17.9525C111.944 17.9525 110.707 18.4936 109.666 19.6072C108.789 20.5383 108.309 21.8218 108.309 23.2248V32.3474C108.309 34.6312 106.441 36.4935 104.15 36.4935C101.858 36.4935 99.9902 34.6312 99.9902 32.3474V7.09336C99.9902 4.80955 101.858 2.94727 104.15 2.94727C106.441 2.94727 108.309 4.80955 108.309 7.09336V10.6355C109.893 9.99374 111.61 9.66658 113.447 9.66658C117.151 9.66658 120.351 10.9878 122.964 13.5862C125.577 16.1909 126.897 19.3807 126.897 23.0738V32.3411C126.903 34.6312 125.035 36.4935 122.744 36.4935Z'
        fill='black'
      />
      <path
        d='M83.698 36.2607C79.9931 36.2607 76.7869 34.9394 74.1802 32.3411C71.5672 29.7364 70.248 26.5466 70.248 22.8535C70.248 19.1604 71.5735 15.9643 74.1865 13.3659C76.7995 10.7612 79.9995 9.44629 83.7044 9.44629C87.4093 9.44629 90.6156 10.7675 93.2222 13.3722C95.8352 15.9769 97.1607 19.1667 97.1607 22.8598V32.5738C97.1607 33.3099 96.7946 34.3921 96.094 35.0275C95.2988 35.751 94.1942 36.1537 92.9887 36.1537C91.7516 36.1537 90.6282 35.7322 89.9023 35.0086C89.8582 34.9646 89.8203 34.9206 89.7761 34.8765C87.9458 35.7888 85.9071 36.2607 83.698 36.2607ZM83.698 17.7259C82.1517 17.7259 80.8831 18.2984 79.8227 19.4875C79.078 20.318 78.6298 21.3813 78.573 22.4949C78.4784 24.1999 79.0527 25.584 80.3277 26.7227C81.1608 27.4651 82.2274 27.9055 83.3383 27.9685C83.4582 27.9748 83.5781 27.981 83.698 27.981C85.2444 27.981 86.513 27.4085 87.5797 26.2194C88.3244 25.3889 88.7663 24.3257 88.8294 23.2184C88.9241 21.5134 88.3497 20.1293 87.0748 18.9905C86.2416 18.2481 85.175 17.8077 84.0641 17.7448C83.9316 17.7322 83.8117 17.7259 83.698 17.7259Z'
        fill='black'
      />
      <path
        d='M63.4954 36.4056C61.0086 36.4056 58.9826 34.386 58.9826 31.9072V22.967C58.9826 21.7968 58.6102 20.702 57.9412 19.8841C56.8304 18.5315 55.4923 17.8709 53.845 17.8709C53.6746 17.8709 53.5042 17.8772 53.3274 17.8897C52.3049 17.9652 51.314 18.3868 50.5377 19.0662C49.3069 20.1421 48.7073 21.4256 48.7073 22.9921V32.1777C48.7073 34.5056 46.8076 36.4056 44.466 36.4056C42.219 36.4056 40.3887 34.5811 40.3887 32.3413V22.9984C40.3887 19.3053 41.7141 16.1092 44.3208 13.5109C46.9338 10.9062 50.1338 9.58496 53.8387 9.58496C57.5436 9.58496 60.7499 10.9062 63.3565 13.5046C65.9695 16.1092 67.2887 19.299 67.2887 22.9921V32.6118C67.3013 34.7069 65.5972 36.4056 63.4954 36.4056Z'
        fill='black'
      />
      <path
        d='M35.0736 13.5926C32.4606 10.9879 29.2606 9.67297 25.5557 9.67297C23.8768 9.67297 22.3053 9.9498 20.841 10.4909C19.0295 11.1578 17.054 11.2333 15.2615 10.5097L9.65052 8.2448C9.13928 8.06864 8.89313 8.36434 9.16453 8.8362L11.7965 13.4542C12.8063 15.2284 13.1724 17.336 12.6107 19.299C12.2698 20.4943 12.0994 21.7589 12.0994 23.0864C12.0994 26.7796 13.4249 29.9756 16.0315 32.574C18.6445 35.1787 21.8445 36.4999 25.5494 36.4999C29.2543 36.4999 32.4606 35.1787 35.0673 32.5803C37.6803 29.9756 39.0057 26.7858 39.0057 23.0927C39.012 19.387 37.6866 16.191 35.0736 13.5926ZM29.1912 26.7041C28.175 27.7107 26.9885 28.2014 25.5557 28.2014C24.123 28.2014 22.9364 27.7107 21.9203 26.7041C20.9041 25.6911 20.4118 24.5083 20.4118 23.0802C20.4118 21.652 20.9041 20.4692 21.9203 19.4562C22.9364 18.4496 24.123 17.9589 25.5557 17.9589C26.9885 17.9589 28.175 18.4496 29.1912 19.4625C30.2011 20.4692 30.6934 21.6583 30.6934 23.0864C30.6934 24.5083 30.2011 25.6911 29.1912 26.7041Z'
        fill='url(#paint0_radial_12683_44538)'
      />
      <path
        d='M4.48123 0.5C3.23785 0.5 2.1775 0.934113 1.3065 1.80234C0.4355 2.67057 0 3.72754 0 4.96696C0 6.20639 0.4355 7.26336 1.3065 8.13159C2.1775 8.99981 3.23785 9.43392 4.48123 9.43392C5.72462 9.43392 6.78497 8.99981 7.65597 8.13159C8.52697 7.26336 8.96247 6.20639 8.96247 4.96696C8.96247 3.72754 8.52697 2.67057 7.65597 1.80234C6.79128 0.934113 5.73093 0.5 4.48123 0.5Z'
        fill='url(#paint1_radial_12683_44538)'
      />
      <path
        d='M4.25505 36.4934C1.96394 36.4934 0.0957031 34.6311 0.0957031 32.3473V14.5675C0.0957031 12.2837 1.96394 10.4214 4.25505 10.4214C6.54616 10.4214 8.41439 12.2837 8.41439 14.5675V32.3473C8.41439 34.6311 6.54616 36.4934 4.25505 36.4934Z'
        fill='white'
      />
      <path
        d='M122.744 36.4935C120.452 36.4935 118.584 34.6312 118.584 32.3474V23.2248C118.584 21.8281 118.105 20.5383 117.227 19.6072C116.186 18.4936 114.949 17.9525 113.447 17.9525C111.944 17.9525 110.707 18.4936 109.666 19.6072C108.789 20.5383 108.309 21.8218 108.309 23.2248V32.3474C108.309 34.6312 106.441 36.4935 104.15 36.4935C101.858 36.4935 99.9902 34.6312 99.9902 32.3474V7.09336C99.9902 4.80955 101.858 2.94727 104.15 2.94727C106.441 2.94727 108.309 4.80955 108.309 7.09336V10.6355C109.893 9.99374 111.61 9.66658 113.447 9.66658C117.151 9.66658 120.351 10.9878 122.964 13.5862C125.577 16.1909 126.897 19.3807 126.897 23.0738V32.3411C126.903 34.6312 125.035 36.4935 122.744 36.4935Z'
        fill='white'
      />
      <path
        d='M83.698 36.2607C79.9931 36.2607 76.7869 34.9394 74.1802 32.3411C71.5672 29.7364 70.248 26.5466 70.248 22.8535C70.248 19.1604 71.5735 15.9643 74.1865 13.3659C76.7995 10.7612 79.9995 9.44629 83.7044 9.44629C87.4093 9.44629 90.6156 10.7675 93.2222 13.3722C95.8352 15.9769 97.1607 19.1667 97.1607 22.8598V32.5738C97.1607 33.3099 96.7946 34.3921 96.094 35.0275C95.2988 35.751 94.1942 36.1537 92.9887 36.1537C91.7516 36.1537 90.6282 35.7322 89.9023 35.0086C89.8582 34.9646 89.8203 34.9206 89.7761 34.8765C87.9458 35.7888 85.9071 36.2607 83.698 36.2607ZM83.698 17.7259C82.1517 17.7259 80.8831 18.2984 79.8227 19.4875C79.078 20.318 78.6298 21.3813 78.573 22.4949C78.4784 24.1999 79.0527 25.584 80.3277 26.7227C81.1608 27.4651 82.2274 27.9055 83.3383 27.9685C83.4582 27.9748 83.5781 27.981 83.698 27.981C85.2444 27.981 86.513 27.4085 87.5797 26.2194C88.3244 25.3889 88.7663 24.3257 88.8294 23.2184C88.9241 21.5134 88.3497 20.1293 87.0748 18.9905C86.2416 18.2481 85.175 17.8077 84.0641 17.7448C83.9316 17.7322 83.8117 17.7259 83.698 17.7259Z'
        fill='white'
      />
      <path
        d='M63.4954 36.4056C61.0086 36.4056 58.9826 34.386 58.9826 31.9072V22.967C58.9826 21.7968 58.6102 20.702 57.9412 19.8841C56.8304 18.5315 55.4923 17.8709 53.845 17.8709C53.6746 17.8709 53.5042 17.8772 53.3274 17.8897C52.3049 17.9652 51.314 18.3868 50.5377 19.0662C49.3069 20.1421 48.7073 21.4256 48.7073 22.9921V32.1777C48.7073 34.5056 46.8076 36.4056 44.466 36.4056C42.219 36.4056 40.3887 34.5811 40.3887 32.3413V22.9984C40.3887 19.3053 41.7141 16.1092 44.3208 13.5109C46.9338 10.9062 50.1338 9.58496 53.8387 9.58496C57.5436 9.58496 60.7499 10.9062 63.3565 13.5046C65.9695 16.1092 67.2887 19.299 67.2887 22.9921V32.6118C67.3013 34.7069 65.5972 36.4056 63.4954 36.4056Z'
        fill='white'
      />
      <path
        d='M35.0736 13.5926C32.4606 10.9879 29.2606 9.67297 25.5557 9.67297C23.8768 9.67297 22.3053 9.9498 20.841 10.4909C19.0295 11.1578 17.054 11.2333 15.2615 10.5097L9.65052 8.2448C9.13928 8.06864 8.89313 8.36434 9.16453 8.8362L11.7965 13.4542C12.8063 15.2284 13.1724 17.336 12.6107 19.299C12.2698 20.4943 12.0994 21.7589 12.0994 23.0864C12.0994 26.7796 13.4249 29.9756 16.0315 32.574C18.6445 35.1787 21.8445 36.4999 25.5494 36.4999C29.2543 36.4999 32.4606 35.1787 35.0673 32.5803C37.6803 29.9756 39.0057 26.7858 39.0057 23.0927C39.012 19.387 37.6866 16.191 35.0736 13.5926ZM29.1912 26.7041C28.175 27.7107 26.9885 28.2014 25.5557 28.2014C24.123 28.2014 22.9364 27.7107 21.9203 26.7041C20.9041 25.6911 20.4118 24.5083 20.4118 23.0802C20.4118 21.652 20.9041 20.4692 21.9203 19.4562C22.9364 18.4496 24.123 17.9589 25.5557 17.9589C26.9885 17.9589 28.175 18.4496 29.1912 19.4625C30.2011 20.4692 30.6934 21.6583 30.6934 23.0864C30.6934 24.5083 30.2011 25.6911 29.1912 26.7041Z'
        fill='url(#paint2_radial_12683_44538)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.65811 3.30874) scale(49.9707 49.8116)'
        >
          <stop stopColor='#004C96' />
          <stop offset='0.00278669' stopColor='#004E96' />
          <stop offset='0.0705' stopColor='#00869B' />
          <stop offset='0.1333' stopColor='#00B29F' />
          <stop offset='0.1893' stopColor='#00D2A2' />
          <stop offset='0.2363' stopColor='#00E5A3' />
          <stop offset='0.2688' stopColor='#00ECA4' />
          <stop offset='0.6341' stopColor='#00B18C' />
          <stop offset='1' stopColor='#1E2492' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.81549 3.13041) scale(36.1413 36.0262)'
        >
          <stop stopColor='#4FFFA4' />
          <stop offset='0.0389' stopColor='#3FE79F' />
          <stop offset='0.1141' stopColor='#24BF97' />
          <stop offset='0.1827' stopColor='#10A191' />
          <stop offset='0.2417' stopColor='#048F8D' />
          <stop offset='0.2844' stopColor='#00898C' />
          <stop offset='0.3647' stopColor='#00778F' />
          <stop offset='0.4957' stopColor='#005F93' />
          <stop offset='0.6179' stopColor='#005195' />
          <stop offset='0.7218' stopColor='#004C96' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_12683_44538'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(3.65811 3.30874) scale(49.9707 49.8116)'
        >
          <stop stopColor='#00ECA4' />
          <stop offset='0.3946' stopColor='#00B1A6' />
          <stop offset='0.4002' stopColor='#00B0A7' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8184' stopColor='#064BF2' />
          <stop offset='0.9368' stopColor='#172FCE' />
          <stop offset='1' stopColor='#1E24C0' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const MiniLogo = () => {
  return (
    <svg
      width={30}
      height={28}
      viewBox='0 0 30 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.9708 9.82576C24.9638 7.87232 22.4982 6.8773 19.6493 6.8773C18.3564 6.8773 17.1537 7.08216 16.0262 7.49187C14.6356 7.99669 13.1172 8.04791 11.7341 7.5065L7.41941 5.80912C7.02853 5.67743 6.84061 5.90423 7.05108 6.25542L9.07312 9.72334C9.84735 11.0549 10.133 12.6425 9.69702 14.1131C9.43393 15.013 9.29862 15.9568 9.29862 16.9591C9.29862 19.732 10.3134 22.1318 12.3279 24.0852C14.3349 26.0387 16.8004 27.0337 19.6493 27.0337C22.4982 27.0337 24.9638 26.046 26.9708 24.0852C28.9778 22.1318 30 19.732 30 16.9591C29.9925 14.179 28.9778 11.7792 26.9708 9.82576ZM22.4456 19.6735C21.6639 20.4344 20.7543 20.8002 19.6493 20.8002C18.5519 20.8002 17.6348 20.4344 16.8531 19.6735C16.0713 18.9126 15.6955 18.0273 15.6955 16.9518C15.6955 15.8837 16.0713 14.9911 16.8531 14.2302C17.6348 13.4693 18.5444 13.1035 19.6493 13.1035C20.7468 13.1035 21.6639 13.4693 22.4456 14.2302C23.2274 14.9911 23.6032 15.8763 23.6032 16.9518C23.6032 18.02 23.2198 18.9126 22.4456 19.6735Z'
        fill='#004C93'
      />
      <path
        d='M3.45024 0C2.48808 0 1.67626 0.329233 1.00726 0.980383C0.338259 1.63153 0 2.42169 0 3.35818C0 4.28734 0.338259 5.08482 1.00726 5.73597C1.67626 6.38712 2.48808 6.71635 3.45024 6.71635C4.40488 6.71635 5.22422 6.38712 5.89322 5.73597C6.56222 5.08482 6.90047 4.29466 6.90047 3.35818C6.90047 2.42901 6.56222 1.63153 5.89322 0.980383C5.2167 0.329233 4.40488 0 3.45024 0Z'
        fill='url(#paint0_radial_2060_15718)'
      />
      <path
        d='M26.9708 9.82576C24.9638 7.87232 22.4982 6.8773 19.6493 6.8773C18.3564 6.8773 17.1537 7.08216 16.0262 7.49187C14.6356 7.99669 13.1172 8.04791 11.7341 7.5065L7.41941 5.80912C7.02853 5.67743 6.84061 5.90423 7.05108 6.25542L9.07312 9.72334C9.84735 11.0549 10.133 12.6425 9.69702 14.1131C9.43393 15.013 9.29862 15.9568 9.29862 16.9591C9.29862 19.732 10.3134 22.1318 12.3279 24.0852C14.3349 26.0387 16.8004 27.0337 19.6493 27.0337C22.4982 27.0337 24.9638 26.046 26.9708 24.0852C28.9778 22.1318 30 19.732 30 16.9591C29.9925 14.179 28.9778 11.7792 26.9708 9.82576ZM22.4456 19.6735C21.6639 20.4344 20.7543 20.8002 19.6493 20.8002C18.5519 20.8002 17.6348 20.4344 16.8531 19.6735C16.0713 18.9126 15.6955 18.0273 15.6955 16.9518C15.6955 15.8837 16.0713 14.9911 16.8531 14.2302C17.6348 13.4693 18.5444 13.1035 19.6493 13.1035C20.7468 13.1035 21.6639 13.4693 22.4456 14.2302C23.2274 14.9911 23.6032 15.8763 23.6032 16.9518C23.6032 18.02 23.2198 18.9126 22.4456 19.6735Z'
        fill='url(#paint1_radial_2060_15718)'
      />
      <defs>
        <radialGradient
          id='paint0_radial_2060_15718'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.93368 1.97481) scale(27.7886 27.0471)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_2060_15718'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(2.81293 2.10869) scale(38.422 37.3968)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
      </defs>
    </svg>
  )
}
export const LogoIonahLight = () => {
  return (
    <svg viewBox='0 0 142 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_534_1186)'>
        <path
          d='M4.75884 40C2.18796 40 0.109375 37.9312 0.109375 35.3967V15.6404C0.109375 13.095 2.1989 11.0371 4.75884 11.0371C7.31877 11.0371 9.4083 13.1059 9.4083 15.6404V35.3967C9.4083 37.9421 7.32971 40 4.75884 40Z'
          fill='black'
        />
        <path
          d='M137.35 40C134.779 40 132.7 37.9312 132.7 35.3967V25.2586C132.7 23.6989 132.164 22.28 131.18 21.2402C130.009 20.0054 128.631 19.3989 126.946 19.3989C125.272 19.3989 123.883 19.9946 122.712 21.2402C121.728 22.28 121.191 23.6989 121.191 25.2586V35.3967C121.191 37.9421 119.102 40 116.542 40C113.971 40 111.893 37.9312 111.893 35.3967V7.3328C111.893 4.78744 113.982 2.72949 116.542 2.72949C119.113 2.72949 121.191 4.79827 121.191 7.3328V11.2754C122.964 10.5605 124.889 10.1923 126.946 10.1923C131.092 10.1923 134.68 11.6545 137.601 14.5573C140.522 17.4492 142.01 21.0019 142.01 25.107V35.4075C141.999 37.9421 139.91 40 137.35 40Z'
          fill='#231F20'
        />
        <path
          d='M93.6561 39.7509C89.5098 39.7509 85.9215 38.2887 83.0006 35.3859C80.0796 32.4939 78.5918 28.9412 78.5918 24.8362C78.5918 20.7311 80.0687 17.1785 83.0006 14.2865C85.9215 11.3945 89.5098 9.92148 93.6561 9.92148C97.8023 9.92148 101.391 11.3837 104.312 14.2865C107.232 17.1785 108.72 20.7311 108.72 24.8362V35.635C108.72 36.4582 108.316 37.6604 107.528 38.3645C106.642 39.166 105.406 39.6101 104.06 39.6101C102.671 39.6101 101.412 39.1443 100.614 38.332C100.57 38.2887 100.526 38.2345 100.472 38.1803C98.4149 39.2202 96.1285 39.7509 93.6561 39.7509ZM93.6561 19.1497C91.9276 19.1497 90.5054 19.7888 89.3129 21.0994C88.4815 22.02 87.9782 23.2115 87.9126 24.4354C87.8032 26.3309 88.4487 27.8689 89.8818 29.1362C90.8117 29.9594 92.0041 30.4576 93.2513 30.5226C93.3826 30.5334 93.5248 30.5334 93.6561 30.5334C95.3846 30.5334 96.8068 29.8944 97.9992 28.573C98.8306 27.6523 99.3339 26.4717 99.3995 25.2369C99.5089 23.3415 98.8635 21.8034 97.4303 20.5362C96.5004 19.713 95.308 19.2256 94.0608 19.1497C93.9296 19.1497 93.7873 19.1497 93.6561 19.1497Z'
          fill='#231F20'
        />
        <path
          d='M71.0553 39.9133C68.2766 39.9133 66.012 37.6713 66.012 34.9201V24.977C66.012 23.6772 65.5963 22.4641 64.8414 21.5543C63.6052 20.0487 62.0955 19.3122 60.2576 19.3122C60.0716 19.3122 59.8747 19.323 59.6778 19.3339C58.54 19.4205 57.4242 19.8863 56.549 20.6445C55.1706 21.8359 54.5032 23.2656 54.5032 25.0095V35.2234C54.5032 37.8121 52.3699 39.9242 49.7553 39.9242C47.2391 39.9242 45.1934 37.8987 45.1934 35.4075V25.0203C45.1934 20.9152 46.6702 17.3626 49.5912 14.4706C52.5122 11.5787 56.1004 10.1056 60.2467 10.1056C64.3929 10.1056 67.9812 11.5678 70.9021 14.4706C73.8231 17.3626 75.3 20.9152 75.3 25.0203V35.7108C75.3109 38.0179 73.4074 39.9133 71.0553 39.9133Z'
          fill='#231F20'
        />
        <path
          d='M39.2527 14.5464C36.3318 11.6545 32.7435 10.1814 28.5972 10.1814C26.7156 10.1814 24.9652 10.4847 23.3242 11.0913C21.3003 11.8386 19.0905 11.9144 17.0775 11.1129L10.798 8.60006C10.2291 8.40509 9.95565 8.74087 10.262 9.26077L13.2048 14.3948C14.3316 16.3661 14.7473 18.7165 14.1128 20.8936C13.7299 22.2258 13.533 23.6231 13.533 25.107C13.533 29.212 15.0099 32.7647 17.9418 35.6566C20.8627 38.5486 24.451 40.0217 28.5972 40.0217C32.7435 40.0217 36.3318 38.5594 39.2527 35.6566C42.1737 32.7647 43.6615 29.212 43.6615 25.107C43.6506 20.9911 42.1737 17.4384 39.2527 14.5464ZM32.6669 29.1254C31.5291 30.2518 30.2054 30.7934 28.5972 30.7934C27 30.7934 25.6654 30.2518 24.5276 29.1254C23.3899 27.9989 22.8429 26.6883 22.8429 25.0961C22.8429 23.5148 23.3899 22.1933 24.5276 21.0669C25.6654 19.9404 26.9891 19.3989 28.5972 19.3989C30.1945 19.3989 31.5291 19.9404 32.6669 21.0669C33.8046 22.1933 34.3516 23.5039 34.3516 25.0961C34.3516 26.6775 33.7937 27.9989 32.6669 29.1254Z'
          fill='url(#paint0_radial_534_1186)'
        />
        <path
          d='M5.02142 0C3.62111 0 2.4396 0.487409 1.46595 1.45139C0.492296 2.41538 0 3.58516 0 4.97157C0 6.34714 0.492296 7.52776 1.46595 8.49174C2.4396 9.45573 3.62111 9.94314 5.02142 9.94314C6.41079 9.94314 7.60324 9.45573 8.57689 8.49174C9.55054 7.52776 10.0428 6.35797 10.0428 4.97157C10.0428 3.59599 9.55054 2.41538 8.57689 1.45139C7.5923 0.487409 6.41079 0 5.02142 0Z'
          fill='url(#paint1_radial_534_1186)'
        />
        <path
          d='M4.75884 40C2.18796 40 0.109375 37.9312 0.109375 35.3967V15.6404C0.109375 13.095 2.1989 11.0371 4.75884 11.0371C7.31877 11.0371 9.4083 13.1059 9.4083 15.6404V35.3967C9.4083 37.9421 7.32971 40 4.75884 40Z'
          fill='#161616'
        />
        <path
          d='M137.35 40C134.779 40 132.7 37.9312 132.7 35.3967V25.2586C132.7 23.6989 132.164 22.28 131.18 21.2402C130.009 20.0054 128.631 19.3989 126.946 19.3989C125.272 19.3989 123.883 19.9946 122.712 21.2402C121.728 22.28 121.191 23.6989 121.191 25.2586V35.3967C121.191 37.9421 119.102 40 116.542 40C113.971 40 111.893 37.9312 111.893 35.3967V7.3328C111.893 4.78744 113.982 2.72949 116.542 2.72949C119.113 2.72949 121.191 4.79827 121.191 7.3328V11.2754C122.964 10.5605 124.889 10.1923 126.946 10.1923C131.092 10.1923 134.68 11.6545 137.601 14.5573C140.522 17.4492 142.01 21.0019 142.01 25.107V35.4075C141.999 37.9421 139.91 40 137.35 40Z'
          fill='#161616'
        />
        <path
          d='M93.6561 39.7509C89.5098 39.7509 85.9215 38.2887 83.0006 35.3859C80.0796 32.4939 78.5918 28.9412 78.5918 24.8362C78.5918 20.7311 80.0687 17.1785 83.0006 14.2865C85.9215 11.3945 89.5098 9.92148 93.6561 9.92148C97.8023 9.92148 101.391 11.3837 104.312 14.2865C107.232 17.1785 108.72 20.7311 108.72 24.8362V35.635C108.72 36.4582 108.316 37.6604 107.528 38.3645C106.642 39.166 105.406 39.6101 104.06 39.6101C102.671 39.6101 101.412 39.1443 100.614 38.332C100.57 38.2887 100.526 38.2345 100.472 38.1803C98.4149 39.2202 96.1285 39.7509 93.6561 39.7509ZM93.6561 19.1497C91.9276 19.1497 90.5054 19.7888 89.3129 21.0994C88.4815 22.02 87.9782 23.2115 87.9126 24.4354C87.8032 26.3309 88.4487 27.8689 89.8818 29.1362C90.8117 29.9594 92.0041 30.4576 93.2513 30.5226C93.3826 30.5334 93.5248 30.5334 93.6561 30.5334C95.3846 30.5334 96.8068 29.8944 97.9992 28.573C98.8306 27.6523 99.3339 26.4717 99.3995 25.2369C99.5089 23.3415 98.8635 21.8034 97.4303 20.5362C96.5004 19.713 95.308 19.2256 94.0608 19.1497C93.9296 19.1497 93.7873 19.1497 93.6561 19.1497Z'
          fill='#161616'
        />
        <path
          d='M71.0553 39.9133C68.2766 39.9133 66.012 37.6713 66.012 34.9201V24.977C66.012 23.6772 65.5963 22.4641 64.8414 21.5543C63.6052 20.0487 62.0955 19.3122 60.2576 19.3122C60.0716 19.3122 59.8747 19.323 59.6778 19.3339C58.54 19.4205 57.4242 19.8863 56.549 20.6445C55.1706 21.8359 54.5032 23.2656 54.5032 25.0095V35.2234C54.5032 37.8121 52.3699 39.9242 49.7553 39.9242C47.2391 39.9242 45.1934 37.8987 45.1934 35.4075V25.0203C45.1934 20.9152 46.6702 17.3626 49.5912 14.4706C52.5122 11.5787 56.1004 10.1056 60.2467 10.1056C64.3929 10.1056 67.9812 11.5678 70.9021 14.4706C73.8231 17.3626 75.3 20.9152 75.3 25.0203V35.7108C75.3109 38.0179 73.4074 39.9133 71.0553 39.9133Z'
          fill='#161616'
        />
        <path
          d='M39.2527 14.5464C36.3318 11.6545 32.7435 10.1814 28.5972 10.1814C26.7156 10.1814 24.9652 10.4847 23.3242 11.0913C21.3003 11.8386 19.0905 11.9144 17.0775 11.1129L10.798 8.60006C10.2291 8.40509 9.95565 8.74087 10.262 9.26077L13.2048 14.3948C14.3316 16.3661 14.7473 18.7165 14.1128 20.8936C13.7299 22.2258 13.533 23.6231 13.533 25.107C13.533 29.212 15.0099 32.7647 17.9418 35.6566C20.8627 38.5486 24.451 40.0217 28.5972 40.0217C32.7435 40.0217 36.3318 38.5594 39.2527 35.6566C42.1737 32.7647 43.6615 29.212 43.6615 25.107C43.6506 20.9911 42.1737 17.4384 39.2527 14.5464ZM32.6669 29.1254C31.5291 30.2518 30.2054 30.7934 28.5972 30.7934C27 30.7934 25.6654 30.2518 24.5276 29.1254C23.3899 27.9989 22.8429 26.6883 22.8429 25.0961C22.8429 23.5148 23.3899 22.1933 24.5276 21.0669C25.6654 19.9404 26.9891 19.3989 28.5972 19.3989C30.1945 19.3989 31.5291 19.9404 32.6669 21.0669C33.8046 22.1933 34.3516 23.5039 34.3516 25.0961C34.3516 26.6775 33.7937 27.9989 32.6669 29.1254Z'
          fill='url(#paint2_radial_534_1186)'
        />
      </g>
      <defs>
        <radialGradient
          id='paint0_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09383 3.1218) scale(55.9187 55.3636)'
        >
          <stop stopColor='#004C93' />
          <stop offset='0.068' stopColor='#008398' />
          <stop offset='0.1316' stopColor='#00AF9C' />
          <stop offset='0.1882' stopColor='#00CF9F' />
          <stop offset='0.2359' stopColor='#00E2A0' />
          <stop offset='0.2688' stopColor='#00E9A1' />
          <stop offset='0.6341' stopColor='#00AE89' />
          <stop offset={1} stopColor='#1E248F' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.26963 2.92359) scale(40.4431 40.0416)'
        >
          <stop stopColor='#4FFFA1' />
          <stop offset='0.0428' stopColor='#3DE49C' />
          <stop offset='0.1168' stopColor='#23BC94' />
          <stop offset='0.1843' stopColor='#109E8E' />
          <stop offset='0.2424' stopColor='#048C8A' />
          <stop offset='0.2844' stopColor='#008689' />
          <stop offset='0.3542' stopColor='#00778C' />
          <stop offset='0.4891' stopColor='#005F90' />
          <stop offset='0.6149' stopColor='#005192' />
          <stop offset='0.7218' stopColor='#004C93' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_534_1186'
          cx={0}
          cy={0}
          r={1}
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(4.09383 3.1218) scale(55.9187 55.3636)'
        >
          <stop stopColor='#00E9A1' />
          <stop offset='0.3946' stopColor='#00AEA3' />
          <stop offset='0.4002' stopColor='#00ADA4' />
          <stop offset='0.6579' stopColor='#006EE6' />
          <stop offset='0.7793' stopColor='#0055FF' />
          <stop offset='0.8252' stopColor='#0749EF' />
          <stop offset='0.9391' stopColor='#182ECB' />
          <stop offset={1} stopColor='#1E24BD' />
        </radialGradient>
        <clipPath id='clip0_534_1186'>
          <rect width={142} height={40} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const Heart = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 32 29'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.423 3.79859C27.697 3.06987 26.8349 2.4918 25.8861 2.0974C24.9373 1.703 23.9203 1.5 22.8933 1.5C21.8663 1.5 20.8493 1.703 19.9005 2.0974C18.9517 2.4918 18.0896 3.06987 17.3636 3.79859L15.8568 5.31023L14.3499 3.79859C12.8834 2.32732 10.8943 1.50076 8.82022 1.50076C6.74617 1.50076 4.75706 2.32732 3.29049 3.79859C1.82391 5.26986 1 7.26534 1 9.34603C1 11.4267 1.82391 13.4222 3.29049 14.8935L4.7973 16.4051L15.8568 27.5L26.9162 16.4051L28.423 14.8935C29.1494 14.1651 29.7256 13.3003 30.1188 12.3484C30.5119 11.3966 30.7143 10.3764 30.7143 9.34603C30.7143 8.31571 30.5119 7.29548 30.1188 6.34363C29.7256 5.39178 29.1494 4.52697 28.423 3.79859Z'
        stroke='{stroke}'
        strokeWidth='{2}'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export const Downs = () => {
  return (
    <svg
      width={8}
      height={6}
      viewBox='0 0 8 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.943 0.269C7.90079 0.187965 7.83717 0.120046 7.75907 0.0726213C7.68097 0.025197 7.59137 8.04183e-05 7.5 0H0.5C0.408544 7.81986e-05 0.318862 0.0252388 0.240712 0.0727439C0.162562 0.120249 0.0989375 0.188279 0.0567636 0.26943C0.0145897 0.350581 -0.0045187 0.441746 0.00151773 0.533002C0.00755416 0.624258 0.0385044 0.712111 0.091 0.787L3.591 5.787C3.63714 5.85261 3.69839 5.90616 3.76957 5.94313C3.84076 5.98009 3.91979 5.99939 4 5.99939C4.08021 5.99939 4.15924 5.98009 4.23043 5.94313C4.30161 5.90616 4.36286 5.85261 4.409 5.787L7.909 0.787C7.96154 0.712043 7.9925 0.6241 7.99849 0.532758C8.00449 0.441417 7.98529 0.350182 7.943 0.269Z'
        fill='#2f343733'
      />
    </svg>
  )
}
export const IconCartHome = () => {
  return (
    <img src='/assets/icons/header/shopping-cart.svg' alt='shopping-cart' />
  )
}
export const IconsDownsLocate = () => {
  return (
    <svg
      width={12}
      height={8}
      viewBox='0 0 12 8'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 2L6 6L2 2'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const SearchIcon = () => {
  return (
    <button className='start-[-1px] flex h-[48px] min-w-[48px] items-center justify-center rounded-e-[6px] bg-product-salePrice p-0'>
      <svg
        width={16}
        height={16}
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M11.742 10.3281C12.7121 9.00176 13.1459 7.3582 12.9566 5.72592C12.7674 4.09364 11.9691 2.59292 10.7213 1.52375C9.4735 0.454573 7.86815 -0.104269 6.22616 -0.0410676C4.58416 0.0221341 3.02651 0.702723 1.86459 1.86465C0.702662 3.02657 0.0220731 4.58422 -0.0411286 6.22622C-0.10433 7.86821 0.454512 9.47357 1.52368 10.7214C2.59286 11.9692 4.09358 12.7675 5.72586 12.9567C7.35814 13.1459 9.0017 12.7121 10.328 11.7421L14.293 15.7071C14.4816 15.8892 14.7342 15.99 14.9964 15.9877C15.2586 15.9855 15.5094 15.8803 15.6948 15.6949C15.8802 15.5095 15.9854 15.2587 15.9877 14.9965C15.9899 14.7343 15.8892 14.4817 15.707 14.2931L11.742 10.3281ZM2 6.50006C2 5.61004 2.26392 4.74001 2.75838 3.99999C3.25285 3.25997 3.95565 2.68319 4.77792 2.3426C5.60019 2.002 6.50499 1.91289 7.3779 2.08652C8.25082 2.26016 9.05264 2.68874 9.68198 3.31808C10.3113 3.94741 10.7399 4.74924 10.9135 5.62215C11.0872 6.49506 10.998 7.39986 10.6575 8.22213C10.3169 9.0444 9.74008 9.7472 9.00006 10.2417C8.26004 10.7361 7.39001 11.0001 6.5 11.0001C5.30693 10.9987 4.1631 10.5242 3.31948 9.68058C2.47585 8.83695 2.00132 7.69312 2 6.50006Z'
          fill='white'
        />
      </svg>
    </button>
  )
}
export const Star = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={11}
      height={10}
      viewBox='0 0 11 10'
      fill='none'
    >
      <path
        d='M5.5 0.0310059L6.96946 3.16517L10.2553 3.66776L7.87764 6.10737L8.43893 9.55215L5.5 7.92574L2.56107 9.55215L3.12236 6.10737L0.744718 3.66776L4.03054 3.16517L5.5 0.0310059Z'
        fill='#555555'
      />
    </svg>
  )
}
export const StarRated = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1481_21100)'>
        <path
          d='M15.1441 5.577L10.8271 4.949L8.90008 1.038C8.80851 0.880461 8.67719 0.749722 8.51925 0.658846C8.36132 0.56797 8.18229 0.520142 8.00008 0.520142C7.81786 0.520142 7.63884 0.56797 7.4809 0.658846C7.32297 0.749722 7.19165 0.880461 7.10008 1.038L5.17308 4.95L0.856079 5.577C0.671214 5.60351 0.497468 5.68126 0.354521 5.80144C0.211573 5.92163 0.105137 6.07944 0.0472671 6.257C-0.0106025 6.43456 -0.0175924 6.62479 0.0270889 6.80612C0.0717703 6.98745 0.166337 7.15265 0.300079 7.283L3.42308 10.328L2.68608 14.628C2.65457 14.8119 2.67514 15.0009 2.74546 15.1738C2.81578 15.3466 2.93305 15.4963 3.08401 15.606C3.23497 15.7156 3.41359 15.7808 3.59969 15.7943C3.78579 15.8077 3.97193 15.7688 4.13708 15.682L8.00008 13.651L11.8611 15.68C12.0262 15.7668 12.2124 15.8057 12.3985 15.7923C12.5846 15.7788 12.7632 15.7136 12.9142 15.604C13.0651 15.4943 13.1824 15.3446 13.2527 15.1718C13.323 14.9989 13.3436 14.8099 13.3121 14.626L12.5751 10.326L15.7001 7.283C15.8335 7.15274 15.9278 6.98778 15.9724 6.80674C16.017 6.6257 16.0102 6.43579 15.9525 6.25846C15.8949 6.08113 15.7889 5.92345 15.6464 5.80321C15.5039 5.68296 15.3306 5.60496 15.1461 5.578L15.1441 5.577Z'
          fill='#F2A41C'
        />
      </g>
      <defs>
        <clipPath id='clip0_1481_21100'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.137939)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const StarRate = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_590_6315)'>
        <path
          d='M15.1441 5.43918L10.8271 4.81118L8.90008 0.900179C8.80851 0.742644 8.67719 0.611904 8.51925 0.521028C8.36132 0.430153 8.18229 0.382324 8.00008 0.382324C7.81786 0.382324 7.63884 0.430153 7.4809 0.521028C7.32297 0.611904 7.19165 0.742644 7.10008 0.900179L5.17308 4.81218L0.856079 5.43918C0.671214 5.46569 0.497468 5.54344 0.354521 5.66363C0.211573 5.78381 0.105137 5.94162 0.0472671 6.11918C-0.0106025 6.29675 -0.0175924 6.48697 0.0270889 6.6683C0.0717703 6.84963 0.166337 7.01483 0.300079 7.14518L3.42308 10.1902L2.68608 14.4902C2.65457 14.6741 2.67514 14.8631 2.74546 15.036C2.81578 15.2088 2.93305 15.3585 3.08401 15.4681C3.23497 15.5778 3.41359 15.643 3.59969 15.6565C3.78579 15.6699 3.97193 15.631 4.13708 15.5442L8.00008 13.5132L11.8611 15.5422C12.0262 15.629 12.2124 15.6679 12.3985 15.6545C12.5846 15.641 12.7632 15.5758 12.9142 15.4661C13.0651 15.3565 13.1824 15.2068 13.2527 15.034C13.323 14.8611 13.3436 14.6721 13.3121 14.4882L12.5751 10.1882L15.7001 7.14518C15.8335 7.01492 15.9278 6.84996 15.9724 6.66892C16.017 6.48788 16.0102 6.29797 15.9525 6.12065C15.8949 5.94332 15.7889 5.78563 15.6464 5.66539C15.5039 5.54515 15.3306 5.46714 15.1461 5.44018L15.1441 5.43918Z'
          fill='#F2A41C'
        />
      </g>
      <defs>
        <clipPath id='clip0_590_6315'>
          <rect width={16} height={16} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconDelivery = () => {
  return <img src='/assets/icons/header/tracking.svg' alt='tracking-order' />
}
export const IconDowns = () => {
  return (
    <svg
      width={12}
      height={12}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.97481 4.4709L6.12513 8.32058L2.48236 4.6778'
        stroke='white'
        strokeWidth={2}
        strokeLinecap='round'
      />
    </svg>
  )
}
export const IconLocation = () => {
  return (
    <svg
      width={18}
      height={24}
      viewBox='0 0 18 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17 9C17 13.9 9 22 9 22C9 22 1 13.9 1 9C1 3.9 5.1 1 9 1C12.9 1 17 3.9 17 9Z'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12Z'
        stroke='#212121'
        strokeWidth='1.5'
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const IconSearch = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M11.7411 10.3281C12.7112 9.00176 13.145 7.3582 12.9557 5.72592C12.7665 4.09364 11.9682 2.59292 10.7204 1.52375C9.47259 0.454573 7.86723 -0.104269 6.22524 -0.0410676C4.58325 0.0221341 3.0256 0.702723 1.86367 1.86465C0.701746 3.02657 0.0211575 4.58422 -0.0420441 6.22622C-0.105246 7.86821 0.453597 9.47357 1.52277 10.7214C2.59194 11.9692 4.09267 12.7675 5.72495 12.9567C7.35722 13.1459 9.00078 12.7121 10.3271 11.7421L14.2921 15.7071C14.4807 15.8892 14.7333 15.99 14.9955 15.9877C15.2577 15.9855 15.5085 15.8803 15.6939 15.6949C15.8793 15.5095 15.9845 15.2587 15.9868 14.9965C15.989 14.7343 15.8882 14.4817 15.7061 14.2931L11.7411 10.3281ZM1.99908 6.50006C1.99908 5.61004 2.263 4.74001 2.75747 3.99999C3.25193 3.25997 3.95474 2.68319 4.777 2.3426C5.59927 2.002 6.50407 1.91289 7.37699 2.08652C8.2499 2.26016 9.05172 2.68874 9.68106 3.31808C10.3104 3.94741 10.739 4.74924 10.9126 5.62215C11.0862 6.49506 10.9971 7.39986 10.6565 8.22213C10.3159 9.0444 9.73917 9.7472 8.99915 10.2417C8.25912 10.7361 7.3891 11.0001 6.49908 11.0001C5.30601 10.9987 4.16219 10.5242 3.31856 9.68058C2.47493 8.83695 2.0004 7.69312 1.99908 6.50006Z'
        fill='#303538'
      />
    </svg>
  )
}
export const IconCheckBlue = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={15}
      height={13}
      viewBox='0 0 15 13'
      fill='none'
    >
      <path
        d='M13.2375 0.808838L5 9.20374L1.7625 5.91712L0 7.7133L5 12.8088L15 2.61776L13.2375 0.808838Z'
        fill='#1E42C0'
      />
    </svg>
  )
}
export const IconCheckRed = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={17}
      viewBox='0 0 17 17'
      fill='none'
    >
      <path
        d='M8.5 0.404053C4.084 0.404053 0.5 3.98805 0.5 8.40405C0.5 12.8201 4.084 16.4041 8.5 16.4041C12.916 16.4041 16.5 12.8201 16.5 8.40405C16.5 3.98805 12.916 0.404053 8.5 0.404053ZM8.5 14.8041C4.972 14.8041 2.1 11.9321 2.1 8.40405C2.1 4.87605 4.972 2.00405 8.5 2.00405C12.028 2.00405 14.9 4.87605 14.9 8.40405C14.9 11.9321 12.028 14.8041 8.5 14.8041ZM12.172 4.86805L6.9 10.1401L4.828 8.07605L3.7 9.20405L6.9 12.4041L13.3 6.00405L12.172 4.86805Z'
        fill='#EE2E24'
      />
    </svg>
  )
}
export const Notification = () => {
  return (
    <svg
      width={27}
      height={30}
      viewBox='0 0 27 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21.5 9.66602C21.5 7.54428 20.6571 5.50945 19.1569 4.00916C17.6566 2.50887 15.6217 1.66602 13.5 1.66602C11.3783 1.66602 9.34344 2.50887 7.84315 4.00916C6.34286 5.50945 5.5 7.54428 5.5 9.66602C5.5 18.9993 1.5 21.666 1.5 21.666H25.5C25.5 21.666 21.5 18.9993 21.5 9.66602Z'
        stroke='#ffffff'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.8067 27C15.5723 27.4041 15.2358 27.7395 14.831 27.9727C14.4262 28.2059 13.9672 28.3286 13.5 28.3286C13.0329 28.3286 12.5739 28.2059 12.1691 27.9727C11.7642 27.7395 11.4278 27.4041 11.1934 27'
        stroke='#ffffff'
        strokeWidth={2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const MenuHeader = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15 7H1C0.4 7 0 7.4 0 8C0 8.6 0.4 9 1 9H15C15.6 9 16 8.6 16 8C16 7.4 15.6 7 15 7Z'
        fill='#212121'
      />
      <path
        d='M15 1H1C0.4 1 0 1.4 0 2C0 2.6 0.4 3 1 3H15C15.6 3 16 2.6 16 2C16 1.4 15.6 1 15 1Z'
        fill='#212121'
      />
      <path
        d='M15 13H1C0.4 13 0 13.4 0 14C0 14.6 0.4 15 1 15H15C15.6 15 16 14.6 16 14C16 13.4 15.6 13 15 13Z'
        fill='#212121'
      />
    </svg>
  )
}
export const IconCartHomeMobi = () => {
  return (
    <svg
      width={24}
      height={23}
      viewBox='0 0 24 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        fill='#303538'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        fill='#303538'
      />
      <path
        d='M6 22C6.55228 22 7 21.5523 7 21C7 20.4477 6.55228 20 6 20C5.44772 20 5 20.4477 5 21C5 21.5523 5.44772 22 6 22Z'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M4.8 6H22L20 16H6L4 1H1'
        stroke='#303538'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
////////////////////Delete Later/////////////////////
export const TiviIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 22H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M23 2H1V18H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const AirCondIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 13H3C1.89543 13 1 13.8954 1 15V20C1 21.1046 1.89543 22 3 22H21C22.1046 22 23 21.1046 23 20V15C23 13.8954 22.1046 13 21 13Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 18H5'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M12 7V2'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 9V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M17 9V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const FridgeIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 1H3V23H21V1Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M21 10H3'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d='M7 5V6'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 14V17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const WashingIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 23V1L3 1V23H21Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M12 19C14.7614 19 17 16.7614 17 14C17 11.2386 14.7614 9 12 9C9.23858 9 7 11.2386 7 14C7 16.7614 9.23858 19 12 19Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M7 5H10'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M16 5H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const HobIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 2H1V23H23V2Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M8 20C9.65685 20 11 18.6569 11 17C11 15.3431 9.65685 14 8 14C6.34315 14 5 15.3431 5 17C5 18.6569 6.34315 20 8 20Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 6H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 10H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 15H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M19 19H17'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const MicrowaveIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M23 3H1V21H23V3Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 16H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 12H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M18 8H19'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
      <path
        d='M14 8H5V16H14V8Z'
        stroke='#212121'
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap='square'
      />
    </svg>
  )
}
export const SelectedIcon = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.707 6.707L7.707 10.707C7.512 10.902 7.256 11 7 11C6.744 11 6.488 10.902 6.293 10.707L4.293 8.707C3.902 8.316 3.902 7.684 4.293 7.293C4.684 6.902 5.316 6.902 5.707 7.293L7 8.586L10.293 5.293C10.684 4.902 11.316 4.902 11.707 5.293C12.098 5.684 12.098 6.316 11.707 6.707Z'
        fill='#4294FE'
      />
    </svg>
  )
}

export const IconPlus = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={13}
      height={14}
      viewBox='0 0 13 14'
      fill='none'
    >
      <path
        d='M7.02285 0.674805H5.97634C5.88331 0.674805 5.8368 0.721316 5.8368 0.81434V6.29108H0.639535C0.546512 6.29108 0.5 6.33759 0.5 6.43062V7.47713C0.5 7.57015 0.546512 7.61667 0.639535 7.61667H5.8368V13.0934C5.8368 13.1864 5.88331 13.2329 5.97634 13.2329H7.02285C7.11587 13.2329 7.16238 13.1864 7.16238 13.0934V7.61667H12.3605C12.4535 7.61667 12.5 7.57015 12.5 7.47713V6.43062C12.5 6.33759 12.4535 6.29108 12.3605 6.29108H7.16238V0.81434C7.16238 0.721316 7.11587 0.674805 7.02285 0.674805Z'
        fill='black'
        fillOpacity='0.85'
      />
    </svg>
  )
}
export const CouponIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={30}
      height={31}
      viewBox='0 0 30 31'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 0.5C23.2843 0.5 30 7.21572 30 15.5C30 23.7843 23.2843 30.5 15 30.5C6.71572 30.5 0 23.7843 0 15.5C0 7.21572 6.71572 0.5 15 0.5ZM7.01543 20.6554H9.07207V10.3445H7.01543C6.70884 10.3451 6.41499 10.4673 6.19836 10.6842C5.98172 10.9012 5.85998 11.1952 5.85984 11.5018V13.7506C5.85963 13.8066 5.88141 13.8603 5.92049 13.9004C5.95957 13.9404 6.01281 13.9634 6.06873 13.9646C6.47027 13.9731 6.85246 14.1387 7.1334 14.4257C7.41434 14.7127 7.57167 15.0984 7.57167 15.5C7.57167 15.9016 7.41434 16.2873 7.1334 16.5743C6.85246 16.8613 6.47027 17.0269 6.06873 17.0354C6.01281 17.0366 5.95957 17.0596 5.92049 17.0996C5.88141 17.1397 5.85963 17.1934 5.85984 17.2494V19.4982C5.85998 19.8048 5.98172 20.0988 6.19836 20.3158C6.415 20.5327 6.70884 20.6549 7.01543 20.6554ZM9.49981 20.6554H22.9829C23.2898 20.6552 23.584 20.5332 23.801 20.3162C24.0179 20.0993 24.1399 19.805 24.1402 19.4982V17.2494C24.1401 17.1927 24.1175 17.1383 24.0774 17.0982C24.0373 17.0581 23.9829 17.0355 23.9262 17.0354C23.519 17.0354 23.1285 16.8737 22.8405 16.5857C22.5526 16.2978 22.3908 15.9072 22.3908 15.5C22.3908 15.0928 22.5526 14.7022 22.8405 14.4143C23.1285 14.1263 23.519 13.9646 23.9262 13.9646C23.9829 13.9645 24.0373 13.9419 24.0774 13.9018C24.1175 13.8617 24.1401 13.8073 24.1402 13.7506V11.5018C24.1399 11.1949 24.0179 10.9007 23.801 10.6838C23.584 10.4668 23.2898 10.3448 22.9829 10.3445H9.50004V20.6554H9.49981ZM7.199 11.0586C7.07533 11.0583 6.95434 11.0946 6.85135 11.1631C6.74836 11.2315 6.66799 11.329 6.62042 11.4432C6.57285 11.5573 6.56023 11.683 6.58413 11.8044C6.60804 11.9257 6.66741 12.0372 6.75473 12.1248C6.84204 12.2124 6.95338 12.2721 7.07465 12.2964C7.19591 12.3206 7.32165 12.3084 7.43595 12.2612C7.55025 12.2139 7.64797 12.1339 7.71674 12.0311C7.7855 11.9283 7.82223 11.8074 7.82227 11.6837C7.82237 11.5182 7.7568 11.3594 7.63995 11.2422C7.5231 11.125 7.36451 11.059 7.199 11.0586ZM7.199 11.8807C7.23799 11.8807 7.27611 11.8691 7.30853 11.8475C7.34095 11.8258 7.36622 11.795 7.38115 11.759C7.39608 11.723 7.39999 11.6834 7.39239 11.6451C7.38479 11.6069 7.36602 11.5718 7.33846 11.5442C7.3109 11.5166 7.27578 11.4978 7.23754 11.4902C7.1993 11.4826 7.15967 11.4865 7.12365 11.5014C7.08763 11.5164 7.05684 11.5416 7.03518 11.574C7.01351 11.6065 7.00195 11.6446 7.00195 11.6836C7.00194 11.7094 7.00702 11.7351 7.01692 11.759C7.02682 11.7829 7.04133 11.8046 7.05963 11.8229C7.07793 11.8413 7.09966 11.8558 7.12357 11.8657C7.14749 11.8756 7.17312 11.8807 7.199 11.8807ZM22.801 12.3084C22.9246 12.3084 23.0454 12.2717 23.1482 12.2031C23.251 12.1344 23.3311 12.0368 23.3784 11.9226C23.4257 11.8084 23.4381 11.6827 23.4139 11.5615C23.3898 11.4403 23.3303 11.3289 23.2429 11.2415C23.1555 11.1541 23.0442 11.0946 22.9229 11.0705C22.8017 11.0464 22.676 11.0587 22.5618 11.106C22.4476 11.1534 22.35 11.2335 22.2814 11.3362C22.2127 11.439 22.176 11.5598 22.176 11.6834C22.176 11.7655 22.1922 11.8468 22.2236 11.9226C22.255 11.9985 22.301 12.0674 22.359 12.1254C22.4171 12.1834 22.486 12.2295 22.5618 12.2609C22.6376 12.2923 22.7189 12.3084 22.801 12.3084ZM22.801 11.4863C22.762 11.4863 22.7239 11.4979 22.6915 11.5195C22.659 11.5412 22.6338 11.5719 22.6188 11.608C22.6039 11.644 22.6 11.6836 22.6076 11.7219C22.6152 11.7601 22.634 11.7952 22.6615 11.8228C22.6891 11.8504 22.7242 11.8691 22.7625 11.8768C22.8007 11.8844 22.8403 11.8805 22.8764 11.8655C22.9124 11.8506 22.9432 11.8254 22.9648 11.793C22.9865 11.7605 22.998 11.7224 22.998 11.6834C22.9981 11.6576 22.993 11.6319 22.9831 11.608C22.9732 11.5841 22.9587 11.5624 22.9404 11.544C22.9221 11.5257 22.9003 11.5112 22.8764 11.5013C22.8525 11.4914 22.8269 11.4863 22.801 11.4863ZM7.199 19.9414C7.32261 19.9414 7.44345 19.9048 7.54624 19.8362C7.64904 19.7675 7.72917 19.67 7.7765 19.5558C7.82383 19.4416 7.83625 19.3159 7.81217 19.1947C7.78809 19.0735 7.7286 18.9621 7.64122 18.8747C7.55384 18.7872 7.4425 18.7277 7.32128 18.7035C7.20005 18.6794 7.07439 18.6917 6.96018 18.739C6.84597 18.7863 6.74834 18.8663 6.67964 18.9691C6.61094 19.0718 6.57425 19.1927 6.57422 19.3163C6.57431 19.482 6.64016 19.6409 6.7573 19.7581C6.87443 19.8753 7.0333 19.9412 7.199 19.9414ZM7.199 19.1193C7.15995 19.119 7.12167 19.1303 7.08904 19.1517C7.0564 19.1732 7.03087 19.2038 7.01569 19.2398C7.00051 19.2758 6.99637 19.3155 7.00378 19.3538C7.01119 19.3922 7.02983 19.4275 7.05732 19.4552C7.08482 19.4829 7.11994 19.5019 7.15822 19.5096C7.1965 19.5174 7.23622 19.5136 7.27234 19.4987C7.30845 19.4838 7.33934 19.4586 7.36107 19.4261C7.38281 19.3937 7.39441 19.3555 7.39441 19.3164C7.39435 19.2645 7.3738 19.2146 7.33722 19.1777C7.30063 19.1408 7.25097 19.1198 7.199 19.1193ZM22.801 19.9414C22.9246 19.9414 23.0454 19.9048 23.1482 19.8361C23.251 19.7674 23.3311 19.6698 23.3784 19.5556C23.4257 19.4414 23.4381 19.3158 23.4139 19.1945C23.3898 19.0733 23.3303 18.9619 23.2429 18.8745C23.1555 18.7871 23.0442 18.7276 22.9229 18.7035C22.8017 18.6794 22.676 18.6918 22.5618 18.7391C22.4476 18.7864 22.35 18.8665 22.2814 18.9692C22.2127 19.072 22.176 19.1928 22.176 19.3164C22.1763 19.4821 22.2422 19.641 22.3593 19.7581C22.4765 19.8753 22.6353 19.9412 22.801 19.9414ZM22.801 19.1193C22.762 19.1193 22.7239 19.1309 22.6915 19.1525C22.659 19.1742 22.6338 19.205 22.6188 19.241C22.6039 19.277 22.6 19.3166 22.6076 19.3549C22.6152 19.3931 22.634 19.4282 22.6615 19.4558C22.6891 19.4834 22.7242 19.5022 22.7625 19.5098C22.8007 19.5174 22.8403 19.5135 22.8764 19.4986C22.9124 19.4836 22.9432 19.4584 22.9648 19.426C22.9865 19.3935 22.998 19.3554 22.998 19.3164C22.9981 19.2906 22.993 19.2649 22.9831 19.241C22.9732 19.2171 22.9587 19.1954 22.9404 19.1771C22.9221 19.1587 22.9003 19.1442 22.8764 19.1343C22.8525 19.1244 22.8269 19.1193 22.801 19.1193ZM13.8798 17.9248C13.8502 17.9549 13.83 17.9931 13.822 18.0345C13.8139 18.076 13.8182 18.1189 13.8344 18.1579C13.8506 18.1969 13.8779 18.2303 13.9129 18.2538C13.948 18.2774 13.9892 18.2901 14.0314 18.2904C14.0884 18.2899 14.1429 18.2669 14.183 18.2264L19.3342 13.0752C19.3734 13.0348 19.395 12.9806 19.3945 12.9244C19.3939 12.8682 19.3713 12.8144 19.3314 12.7748C19.2916 12.7351 19.2377 12.7128 19.1815 12.7126C19.1253 12.7124 19.0712 12.7343 19.0311 12.7736L13.8798 17.9248ZM18.2494 15.7299C17.9227 15.7297 17.606 15.8429 17.3533 16.05C17.1005 16.2572 16.9275 16.5455 16.8635 16.8659C16.7996 17.1864 16.8487 17.5191 17.0025 17.8074C17.1564 18.0956 17.4054 18.3217 17.7072 18.4469C18.009 18.5722 18.3449 18.589 18.6576 18.4943C18.9704 18.3997 19.2407 18.1996 19.4224 17.9281C19.6042 17.6565 19.6862 17.3304 19.6544 17.0052C19.6227 16.6799 19.4792 16.3758 19.2483 16.1445C19.1177 16.0126 18.9621 15.908 18.7906 15.8369C18.6191 15.7657 18.4351 15.7295 18.2494 15.7302V15.7299ZM18.9451 17.8389C19.0827 17.7014 19.1764 17.5261 19.2144 17.3352C19.2524 17.1444 19.2329 16.9465 19.1584 16.7668C19.0839 16.587 18.9578 16.4333 18.796 16.3252C18.6342 16.2171 18.444 16.1595 18.2494 16.1595C18.1202 16.1594 17.9923 16.1849 17.8729 16.2343C17.7535 16.2837 17.6451 16.3562 17.5537 16.4475C17.4624 16.5389 17.3899 16.6474 17.3405 16.7667C17.291 16.8861 17.2656 17.0141 17.2656 17.1433C17.2657 17.3378 17.3234 17.528 17.4315 17.6898C17.5396 17.8515 17.6933 17.9776 17.873 18.0521C18.0528 18.1265 18.2506 18.146 18.4414 18.1081C18.6322 18.0701 18.8075 17.9765 18.9451 17.8389ZM13.9657 14.8555C14.1632 15.0527 14.4148 15.1869 14.6885 15.2411C14.9623 15.2954 15.246 15.2673 15.5038 15.1604C15.7616 15.0535 15.9819 14.8726 16.1369 14.6405C16.292 14.4084 16.3747 14.1355 16.3747 13.8564C16.3747 13.5774 16.292 13.3045 16.1369 13.0724C15.9819 12.8403 15.7616 12.6594 15.5038 12.5525C15.246 12.4456 14.9623 12.4175 14.6885 12.4718C14.4148 12.526 14.1632 12.6602 13.9657 12.8574C13.8337 12.9881 13.7288 13.1437 13.6573 13.3152C13.5857 13.4867 13.5489 13.6706 13.5489 13.8564C13.5489 14.0422 13.5857 14.2262 13.6573 14.3977C13.7288 14.5692 13.8337 14.7248 13.9657 14.8555ZM14.2689 13.1609C14.0845 13.3455 13.981 13.5957 13.981 13.8566C13.981 14.1175 14.0845 14.3677 14.2689 14.5523C14.3601 14.6436 14.4685 14.7161 14.5877 14.7655C14.7069 14.8149 14.8347 14.8403 14.9638 14.8403C15.0929 14.8403 15.2207 14.8149 15.3399 14.7655C15.4591 14.7161 15.5674 14.6436 15.6587 14.5523C15.75 14.4611 15.8225 14.3527 15.872 14.2334C15.9215 14.1142 15.947 13.9863 15.9471 13.8572C15.9472 13.7281 15.9218 13.6002 15.8725 13.4809C15.8231 13.3615 15.7508 13.2531 15.6595 13.1617C15.5683 13.0704 15.4599 12.9979 15.3406 12.9484C15.2214 12.8989 15.0935 12.8734 14.9644 12.8733C14.8353 12.8732 14.7074 12.8986 14.5881 12.9479C14.4687 12.9973 14.3603 13.0696 14.2689 13.1609Z'
        fill='#ED1C24'
      />
    </svg>
  )
}
export const CouponIconSimple = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='32px'
      height='32px'
      x='0'
      y='0'
      viewBox='0 0 512 512'
      enableBackground='new 0 0 512 512'
      xmlSpace='preserve'
    >
      <g>
        <path
          d='M497 91H151.245v45c0 8.291-6.709 15-15 15s-15-6.709-15-15V91H15c-8.401 0-15 6.599-15 15v90c0 8.399 6.599 15 15 15 24.901 0 45 20.099 45 45 0 24.899-20.099 45-45 45-8.401 0-15 6.599-15 15v90c0 8.399 6.599 15 15 15h105v-45c0-8.291 6.709-15 15-15s15 6.709 15 15v45h347c8.401 0 15-6.601 15-15V106c0-8.401-6.599-15-15-15zM150 316c0 8.291-6.709 15-15 15s-15-6.709-15-15v-30c0-8.291 6.709-15 15-15s15 6.709 15 15v30zm0-90c0 8.291-6.709 15-15 15s-15-6.709-15-15v-30c0-8.291 6.709-15 15-15s15 6.709 15 15v30z'
          fill='#fd4e26'
          data-original='#fd4e26'
        ></path>
        <path
          d='M60 256c0 24.899-20.099 45-45 45-8.401 0-15 6.599-15 15v90c0 8.399 6.599 15 15 15h105v-45c0-8.291 6.709-15 15-15s15 6.709 15 15v45h347c8.401 0 15-6.601 15-15V256H60zm90 60c0 8.291-6.709 15-15 15s-15-6.709-15-15v-30c0-8.291 6.709-15 15-15s15 6.709 15 15v30z'
          fill='#fd3018'
          data-original='#fd3018'
        ></path>
        <path
          d='M287 241c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z'
          fill='#fedb41'
          data-original='#fedb41'
        ></path>
        <path
          d='M407 361c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z'
          fill='#fcbf29'
          data-original='#fcbf29'
        ></path>
        <path
          d='M419.599 174.399 365.3 256 347 283.299l-47.401 71.1c-4.499 6.601-13.799 8.701-21 4.2-6.899-4.799-8.699-14.099-4.199-21L328.7 256l18.3-27.301 47.401-71.1c4.799-6.899 14.099-8.699 21-4.2 6.899 4.801 8.699 14.101 4.198 21z'
          fill='#fedb41'
          data-original='#fedb41'
        ></path>
        <path
          d='M365.3 256 347 283.299l-47.401 71.1c-4.499 6.601-13.799 8.701-21 4.2-6.899-4.799-8.699-14.099-4.199-21L328.7 256h36.6z'
          fill='#fcbf29'
          data-original='#fcbf29'
        ></path>
      </g>
    </svg>
  )
}
export const CouponArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={7}
      height={13}
      viewBox='0 0 7 13'
      fill='none'
    >
      <path
        d='M1.06125 1.21051C0.693124 1.60051 0.693124 2.23051 1.06125 2.62051L4.72368 6.50051L1.06125 10.3805C0.693124 10.7705 0.693124 11.4005 1.06125 11.7905C1.42939 12.1805 2.02406 12.1805 2.39219 11.7905L6.72481 7.20051C7.09294 6.81051 7.09294 6.18051 6.72481 5.79051L2.39219 1.20051C2.0335 0.82051 1.42939 0.82051 1.06125 1.21051Z'
        fill='#1E42C0'
      />
    </svg>
  )
}

export const CouponArrowDown = ({ className = '' }) => {
  return (
    <svg
      className={`${className}`}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.00041 11.0006C7.73521 11.0005 7.4809 10.8951 7.29341 10.7076L3.29341 6.70757C3.11125 6.51897 3.01045 6.26636 3.01273 6.00417C3.01501 5.74197 3.12018 5.49116 3.30559 5.30575C3.491 5.12034 3.74181 5.01517 4.00401 5.0129C4.2662 5.01062 4.5188 5.11141 4.70741 5.29357L8.00041 8.58657L11.2934 5.29357C11.3857 5.19806 11.496 5.12188 11.618 5.06947C11.74 5.01706 11.8712 4.98947 12.004 4.98832C12.1368 4.98717 12.2685 5.01247 12.3914 5.06275C12.5143 5.11303 12.6259 5.18728 12.7198 5.28117C12.8137 5.37507 12.8879 5.48672 12.9382 5.60962C12.9885 5.73251 13.0138 5.86419 13.0127 5.99697C13.0115 6.12975 12.9839 6.26097 12.9315 6.38297C12.8791 6.50498 12.8029 6.61532 12.7074 6.70757L8.70741 10.7076C8.51991 10.8951 8.2656 11.0005 8.00041 11.0006Z'
        fill='#303538'
      />
    </svg>
  )
}
export const IconFilter = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={18}
      height={18}
      viewBox='0 0 20 21'
      fill='none'
    >
      <g clipPath='url(#clip0_1387_33389)'>
        <path
          d='M18.9248 0.114259H1.09382C0.779325 0.113664 0.491008 0.289351 0.347247 0.569141C0.201502 0.852698 0.227082 1.19416 0.413278 1.45313L6.9458 10.6555C6.94799 10.6586 6.95036 10.6616 6.95255 10.6648C7.1899 10.9852 7.3182 11.3733 7.31899 11.7722V19.2748C7.3176 19.4971 7.40485 19.7104 7.5615 19.8681C7.71815 20.0257 7.93112 20.1142 8.1532 20.1142C8.26623 20.1142 8.37787 20.0916 8.48217 20.0483L12.1529 18.6486C12.4819 18.5483 12.7002 18.2379 12.7002 17.8642V11.7722C12.7008 11.3735 12.8293 10.9852 13.0665 10.6648C13.0687 10.6616 13.071 10.6586 13.0732 10.6555L19.6055 1.45273C19.7917 1.19396 19.8173 0.852698 19.6716 0.569141C19.5278 0.289351 19.2395 0.113664 18.9248 0.114259ZM12.2479 10.0634C11.8831 10.5585 11.6858 11.1571 11.6846 11.7722V17.7408L8.33424 19.0182V11.7722C8.33305 11.1571 8.13575 10.5585 7.7707 10.0634L1.42873 1.12951H18.5901L12.2479 10.0634Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_1387_33389'>
          <rect
            width={20}
            height={20}
            fill='white'
            transform='translate(0 0.114258)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export const LogoIconF = () => {
  return (
    <svg
      width={120}
      height={120}
      viewBox='0 0 66 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M33 66C51.2254 66 66 51.2254 66 33C66 14.7746 51.2254 0 33 0C14.7746 0 0 14.7746 0 33C0 51.2254 14.7746 66 33 66Z'
        fill='url(#paint0_linear_238_13755)'
      />
      <g clipPath='url(#clip0_238_13755)'>
        <path
          d='M14.7377 20.4044C15.0577 21.3111 14.5791 22.3042 13.6738 22.6224C12.7646 22.9419 11.7727 22.4653 11.4514 21.5587C11.1327 20.652 11.61 19.6602 12.5179 19.3407C13.4258 19.0212 14.4191 19.4965 14.7377 20.4044Z'
          fill='white'
        />
        <path
          d='M23.4689 17.1847C22.7223 16.7521 19.1186 14.6659 18.108 14.0868C17.932 13.9696 17.8747 14.1946 17.988 14.2825C20.1772 15.8907 21.753 18.6426 21.3277 22.0973C20.9211 25.399 18.4773 27.9311 15.9455 28.7872C13.6964 29.5474 12.7938 29.795 12.3992 29.9148C12.7058 30.7921 13.3778 33.0927 11.9886 35.6833C11.166 37.2184 9.43946 38.7121 7.30099 39.1528C7.213 39.1714 7.11035 39.1981 7.193 39.2421C7.29166 39.298 10.8047 41.3215 10.8047 41.3215C12.2352 42.1469 14.7163 41.8221 16.1802 40.9941C16.9721 40.5454 17.5534 40.0023 18.2067 39.2567C19.3999 37.896 19.7999 35.8418 19.6239 34.0712C20.2465 33.8288 23.2422 32.8678 24.6087 31.8345C25.8514 30.8946 27.5298 29.132 27.9311 25.825C28.407 21.9029 26.2859 18.8169 23.4689 17.1847Z'
          fill='white'
        />
        <path
          d='M28.0193 47.3059C28.0193 47.744 28.2939 48.0142 28.7005 48.0142H29.947C30.0831 48.0142 30.1017 48.0727 30.1017 48.1499V48.616C30.1017 48.7117 30.0831 48.7596 29.9271 48.7596C29.6552 48.7596 28.8658 48.7596 27.0367 48.7596C25.3249 48.7596 23.7703 48.7596 23.557 48.7596C23.4224 48.7596 23.3877 48.7104 23.3877 48.6346V48.1499C23.3877 48.05 23.4224 48.0142 23.5184 48.0142H24.3557C25.0422 48.0155 25.2648 47.7825 25.2648 47.3059C25.2648 47.1102 25.2648 36.4423 25.2648 36.2213C25.2648 35.8299 25.0223 35.6648 24.4969 35.6648H23.5077C23.4104 35.6648 23.3877 35.6262 23.3877 35.5104V35.0378C23.3877 34.9406 23.4037 34.9141 23.501 34.9141C23.7143 34.9141 24.4982 34.9141 26.3474 34.9141C26.6967 34.9141 28.154 34.9141 28.7965 34.9141C30.995 34.9141 32.0723 35.1149 33.1814 35.8725C34.0947 36.4942 34.6587 37.582 34.6587 38.6896C34.6587 41.1379 32.4203 42.6796 29.5791 42.6796C28.8578 42.6796 28.6419 42.6303 28.0193 42.5517C28.0193 42.5517 28.0193 47.033 28.0193 47.3059ZM28.0193 41.8036C28.2859 41.8807 28.6832 42.0592 29.2472 42.0592C30.1658 42.0592 30.867 41.5972 31.4256 40.7105C31.8017 40.1115 31.9763 39.4286 31.9763 38.7481C31.9763 36.2028 30.2165 35.5223 29.0685 35.5223C28.7379 35.5223 28.41 35.5223 28.0193 35.6595V41.8036Z'
          fill='white'
        />
        <path
          d='M34.9573 43.5693C34.9573 42.9328 35.0226 42.5029 34.3825 42.419C34.2453 42.4017 34.2079 42.3591 34.2079 42.2819V42.1074C34.2079 42.0489 34.248 42.0144 34.3427 41.9718C35.2025 41.5936 36.1277 41.0317 36.8957 40.4167C37.0317 40.3088 37.1076 40.281 37.2224 40.3009C37.2996 40.3155 37.3383 40.3808 37.3383 40.486C37.3383 40.8227 37.3383 47.0905 37.3383 47.305C37.3383 47.775 37.581 48.0118 37.8983 48.0158H38.5488C38.7035 48.0118 38.7435 48.0651 38.7435 48.1823V48.5776C38.7435 48.7135 38.7048 48.7627 38.5689 48.7627C38.4143 48.7627 37.2357 48.7627 36.4171 48.7627C35.2892 48.7627 33.8533 48.7627 33.64 48.7627C33.5427 48.7627 33.4854 48.7334 33.4854 48.6163V48.1623C33.4854 48.0452 33.5427 48.0078 33.68 48.0145H34.4212C34.7385 48.0118 34.9573 47.7803 34.9573 47.3024C34.9573 46.7165 34.9573 43.5693 34.9573 43.5693Z'
          fill='white'
        />
        <path
          d='M40.9234 44.0414C40.9207 45.0839 41.282 46.3033 41.7913 46.9358C42.4965 47.8131 43.2044 47.9808 43.8604 47.9808C44.5843 47.9808 45.0764 47.4057 45.5308 46.8598C45.5656 46.8185 45.6282 46.8026 45.6868 46.8598L46.1014 47.2765C46.1788 47.3538 46.1988 47.411 46.1014 47.5268C45.5416 48.1633 44.3563 48.8542 42.9911 48.8502C41.9659 48.8475 40.4446 48.6399 39.5554 47.5215C38.8395 46.5763 38.6543 45.9653 38.6036 45.0985C38.4182 41.9273 40.8833 40.4336 43.2604 40.4336C45.2695 40.4336 45.8881 41.5453 45.8881 41.9499C45.8695 42.3946 45.5788 42.6263 45.1735 42.6263C44.7283 42.6263 44.4003 42.3747 44.1097 41.8542C43.6843 41.0633 43.2792 40.9954 42.8151 40.9954C41.7152 40.9941 40.93 41.8714 40.9234 44.0414Z'
          fill='white'
        />
        <path
          d='M47.4148 47.5552C46.5256 46.4927 46.3389 45.8417 46.3097 44.4719C46.2869 43.4001 46.9203 42.1872 48.0615 41.298C49.0667 40.5258 50.5412 40.4459 51.1784 40.4326C52.3344 40.4087 53.769 40.8307 54.4783 41.5269C55.4088 42.4402 55.8195 43.3855 55.8195 44.6396C55.8195 46.7444 53.6743 48.7999 50.9265 48.8492C49.9985 48.8651 48.2268 48.5204 47.4148 47.5552ZM53.3743 44.4146C53.3743 42.2898 52.0092 40.9971 51.0225 40.9971C50.5012 40.9971 49.972 41.089 49.5333 41.6095C48.9573 42.2937 48.7268 43.468 48.7788 44.5691C48.8294 45.6501 49.0348 46.5526 49.512 47.2024C49.9693 47.8254 50.4279 48.2155 51.2519 48.1981C52.7196 48.1663 53.3743 46.4636 53.3743 44.4146Z'
          fill='white'
        />
        <path
          d='M56.1726 48.7614C55.9418 48.7614 55.7458 48.6802 55.5872 48.5232C55.4285 48.3634 55.3486 48.1677 55.3486 47.9373C55.3486 47.7031 55.4259 47.5073 55.5845 47.3516C55.7418 47.1932 55.9365 47.1172 56.1739 47.1172C56.4044 47.1172 56.6005 47.1958 56.7578 47.3569C56.9164 47.5166 56.9965 47.7084 56.9965 47.9373C56.9965 48.165 56.9164 48.3581 56.7578 48.5192C56.6018 48.6802 56.4058 48.7614 56.1726 48.7614ZM55.4858 47.9386C55.4858 48.1304 55.5511 48.2914 55.6832 48.4246C55.8152 48.5592 55.9792 48.627 56.1752 48.627C56.3644 48.627 56.5257 48.5605 56.6591 48.4299C56.7938 48.2981 56.8618 48.1343 56.8618 47.9399C56.8618 47.7669 56.7965 47.6072 56.6711 47.4674C56.5432 47.325 56.3765 47.2557 56.1726 47.2557C55.9819 47.2557 55.8192 47.3209 55.6872 47.4554C55.5526 47.586 55.4858 47.7497 55.4858 47.9386Z'
          fill='white'
        />
        <path
          d='M55.8164 47.4971H56.2151C56.2805 47.4971 56.3352 47.5065 56.3777 47.5278C56.4604 47.5638 56.5005 47.6342 56.5005 47.7368C56.5005 47.7887 56.4885 47.8313 56.4671 47.8673C56.4458 47.8992 56.4137 47.9259 56.375 47.9471C56.4111 47.9604 56.4352 47.9778 56.4538 48.003C56.4697 48.0231 56.4817 48.0615 56.4843 48.1148L56.4872 48.2321C56.4872 48.2679 56.4912 48.2933 56.4965 48.3092C56.5031 48.3359 56.5164 48.3545 56.535 48.3611V48.3825H56.3872C56.3845 48.3744 56.3804 48.3638 56.3777 48.3505C56.375 48.3386 56.3737 48.3145 56.3724 48.2813L56.3644 48.1322C56.3618 48.0737 56.3405 48.0377 56.3018 48.0178C56.2805 48.007 56.2445 48.003 56.1978 48.003H55.9352V48.3825H55.8164V47.4971ZM56.2018 47.9005C56.2564 47.9005 56.2991 47.8899 56.3297 47.8673C56.3631 47.8446 56.3777 47.8046 56.3777 47.7487C56.3777 47.6835 56.3551 47.6422 56.3111 47.6183C56.2872 47.609 56.2551 47.6022 56.2177 47.6022H55.9352V47.9005H56.2018Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_238_13755'
          x1={66}
          y1={62}
          x2='5.70083e-08'
          y2='4.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF0000' />
          <stop offset={1} stopColor='#BA0000' />
        </linearGradient>
        <clipPath id='clip0_238_13755'>
          <rect
            width={50}
            height={35}
            fill='white'
            transform='translate(7 14)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconMenu = () => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.6673 28V25.3333C26.6673 23.9188 26.1054 22.5623 25.1052 21.5621C24.105 20.5619 22.7485 20 21.334 20H10.6673C9.25283 20 7.89628 20.5619 6.89608 21.5621C5.89589 22.5623 5.33398 23.9188 5.33398 25.3333V28'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.9993 14.6667C18.9449 14.6667 21.3327 12.2789 21.3327 9.33333C21.3327 6.38781 18.9449 4 15.9993 4C13.0538 4 10.666 6.38781 10.666 9.33333C10.666 12.2789 13.0538 14.6667 15.9993 14.6667Z'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
export const IconListOrder = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={26}
      height={25}
      viewBox='0 0 26 25'
      fill={active ? 'white' : 'black'}
    >
      <path
        d='M22.4937 18.875C22.4937 20.8836 20.7899 22.525 18.6875 22.525H7.75C5.64756 22.525 3.94375 20.8836 3.94375 18.875V5.375C3.94375 3.36641 5.64756 1.725 7.75 1.725H18.6875C20.7899 1.725 22.4937 3.36641 22.4937 5.375V18.875ZM7.75 3.025C6.40624 3.025 5.30625 4.07524 5.30625 5.375V18.875C5.30625 20.1748 6.40624 21.225 7.75 21.225H18.6875C20.0313 21.225 21.1313 20.1748 21.1313 18.875V5.375C21.1313 4.07524 20.0313 3.025 18.6875 3.025H7.75Z'
        fill={active ? 'white' : 'black'}
        stroke='white'
        strokeWidth='0.2'
      />
      <path
        d='M11.6562 12.875H17.9062C18.3381 12.875 18.6875 12.5392 18.6875 12.125C18.6875 11.7108 18.3381 11.375 17.9062 11.375H11.6562C11.2244 11.375 10.875 11.7108 10.875 12.125C10.875 12.5392 11.2244 12.875 11.6562 12.875Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M11.6562 9.125H17.9062C18.3381 9.125 18.6875 8.78918 18.6875 8.375C18.6875 7.96082 18.3381 7.625 17.9062 7.625H11.6562C11.2244 7.625 10.875 7.96082 10.875 8.375C10.875 8.78918 11.2244 9.125 11.6562 9.125Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M11.6562 16.625H17.9062C18.3381 16.625 18.6875 16.2892 18.6875 15.875C18.6875 15.4608 18.3381 15.125 17.9062 15.125H11.6562C11.2244 15.125 10.875 15.4608 10.875 15.875C10.875 16.2892 11.2244 16.625 11.6562 16.625Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M8.54654 9.125C8.97836 9.125 9.32779 8.78918 9.32779 8.375C9.32779 7.96082 8.97836 7.625 8.54654 7.625H8.53891C8.10785 7.625 7.76147 7.96082 7.76147 8.375C7.76147 8.78918 8.11548 9.125 8.54654 9.125Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M8.54654 12.875C8.97836 12.875 9.32779 12.5392 9.32779 12.125C9.32779 11.7108 8.97836 11.375 8.54654 11.375H8.53891C8.10785 11.375 7.76147 11.7108 7.76147 12.125C7.76147 12.5392 8.11548 12.875 8.54654 12.875Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M8.54654 16.625C8.97836 16.625 9.32779 16.2892 9.32779 15.875C9.32779 15.4608 8.97836 15.125 8.54654 15.125H8.53891C8.10785 15.125 7.76147 15.4608 7.76147 15.875C7.76147 16.2892 8.11548 16.625 8.54654 16.625Z'
        fill={active ? 'white' : 'black'}
      />
    </svg>
  )
}
export const IconFaq = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={21}
      viewBox='0 0 17 21'
      fill='none'
    >
      <path
        d='M16.5673 5.64962C16.5576 5.10965 16.5484 4.59955 16.5484 4.10606C16.5484 3.71945 16.2526 3.40601 15.8876 3.40601C13.0616 3.40601 10.9099 2.5456 9.11645 0.698219C8.85988 0.43388 8.4516 0.433974 8.19512 0.698219C6.40182 2.5456 4.25053 3.40601 1.42471 3.40601C1.05978 3.40601 0.76392 3.71945 0.76392 4.10606C0.76392 4.59964 0.754757 5.10993 0.744977 5.64999C0.654404 10.675 0.530352 17.5571 8.43935 20.4614C8.50949 20.4871 8.58261 20.5 8.65574 20.5C8.72887 20.5 8.80208 20.4871 8.87213 20.4614C16.7817 17.557 16.6579 10.6748 16.5673 5.64962ZM8.65583 19.0571C1.87282 16.4466 1.97538 10.7282 2.06639 5.67669C2.07185 5.37352 2.07714 5.07969 2.08084 4.79164C4.72754 4.67329 6.84402 3.82361 8.65583 2.15152C10.4678 3.82361 12.5846 4.67338 15.2315 4.79164C15.2352 5.07959 15.2405 5.37324 15.246 5.67622C15.3369 10.7279 15.4394 16.4465 8.65583 19.0571Z'
        fill='#010103'
      />
      <path
        d='M10.9308 8.06828L7.74141 11.4469L6.38044 10.0051C6.12238 9.73178 5.70396 9.73178 5.44599 10.0051C5.18793 10.2786 5.18793 10.7217 5.44599 10.9951L7.27419 12.9319C7.40317 13.0686 7.57234 13.1369 7.74141 13.1369C7.91049 13.1369 8.07965 13.0686 8.20864 12.9319L11.8651 9.05834C12.1233 8.78494 12.1233 8.34167 11.8652 8.06837C11.6072 7.79498 11.1888 7.79489 10.9308 8.06828Z'
        fill='#010103'
      />
    </svg>
  )
}
export const IconRate = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={18}
      viewBox='0 0 17 18'
      fill='none'
    >
      <g clipPath='url(#clip0_3639_8392)'>
        <path
          d='M15.1683 0.65H1.83172C0.766485 0.65 -0.1 1.51645 -0.1 2.58168V13.7844C-0.1 14.8497 0.766482 15.7161 1.83172 15.7161H6.11842L8.07707 17.6748C8.18922 17.787 8.34132 17.85 8.49997 17.85C8.65857 17.85 8.81068 17.787 8.92286 17.6748L10.8815 15.7161H15.1683C16.2335 15.7161 17.1 14.8497 17.1 13.7844V2.58168C17.1 1.51645 16.2335 0.65 15.1683 0.65ZM15.9039 13.7844C15.9039 14.1899 15.5738 14.52 15.1683 14.52H10.6338C10.4752 14.52 10.3231 14.583 10.211 14.6952C10.211 14.6952 10.211 14.6952 10.2109 14.6953L8.49997 16.4062L6.78903 14.6952C6.67688 14.5831 6.52478 14.52 6.36613 14.52H1.83172C1.42619 14.52 1.09609 14.1899 1.09609 13.7844V2.58168C1.09609 2.17616 1.42618 1.84609 1.83172 1.84609H15.1683C15.5738 1.84609 15.9039 2.17616 15.9039 2.58168V13.7844Z'
          fill='black'
          stroke='black'
          strokeWidth='0.2'
        />
        <path
          d='M3.77175 6.80224L3.77175 6.80224C3.83623 6.60381 4.00774 6.45923 4.21417 6.42924L6.83587 6.04819L8.00849 3.67247C8.10082 3.48541 8.29132 3.36699 8.49991 3.36699C8.70853 3.36699 8.89903 3.48541 8.99136 3.67244L10.1641 6.0482L12.7856 6.42924C12.9921 6.45923 13.1636 6.60381 13.228 6.80227C13.228 6.80227 13.228 6.80228 13.228 6.80228L3.77175 6.80224ZM3.77175 6.80224C3.7073 7.00064 3.76108 7.21843 3.91044 7.36402L3.91044 7.36403L5.80764 9.21325M3.77175 6.80224L5.80764 9.21325M5.80764 9.21325L5.35985 11.8244C5.32459 12.03 5.40911 12.2377 5.57786 12.3604L5.57788 12.3604C5.74666 12.483 5.97041 12.4992 6.15503 12.4021L6.13177 12.3579L6.15503 12.4021L8.49991 11.1693L10.845 12.4021L10.8683 12.3579L10.845 12.4021C10.9252 12.4442 11.0128 12.4651 11.1 12.4651H11.102H11.1022C11.4042 12.4643 11.6488 12.2192 11.6488 11.917C11.6488 11.8755 11.6441 11.835 11.6354 11.796L11.1922 9.21325L5.80764 9.21325ZM6.77906 8.62947C6.90823 8.75535 6.96715 8.93675 6.93668 9.11453L6.93668 9.11453L6.62789 10.9152L8.24489 10.0651L8.24489 10.0651C8.40455 9.98113 8.59527 9.98113 8.75494 10.0651L10.3721 10.9151L10.0631 9.11457C10.0326 8.93679 10.0915 8.75534 10.2207 8.62944L11.5291 7.35423L9.72134 7.09146C9.54282 7.06552 9.38856 6.95342 9.30873 6.79171L8.49995 5.15326L7.69126 6.79167C7.61143 6.95342 7.45714 7.06552 7.27866 7.09146L5.47076 7.35423L6.77906 8.62947ZM6.77906 8.62947L6.77906 8.62947L6.74416 8.66528L6.77906 8.62947Z'
          fill='black'
          stroke='black'
          strokeWidth='0.1'
        />
      </g>
      <defs>
        <clipPath id='clip0_3639_8392'>
          <rect
            width={17}
            height={17}
            fill='white'
            transform='translate(0 0.75)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const IconSetting = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={19}
      viewBox='0 0 19 19'
      fill='none'
    >
      <mask
        id='mask0_3639_8396'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={19}
        height={19}
      >
        <path d='M0 5.72205e-06H19V19H0V5.72205e-06Z' fill='white' />
      </mask>
      <g mask='url(#mask0_3639_8396)'>
        <path
          d='M11.2887 2.57098C11.9448 2.74031 12.5646 3.00026 13.1337 3.33684C13.1337 3.33684 13.4079 3.06257 13.7159 2.7546C13.9395 2.53075 14.2429 2.40521 14.5593 2.40521C14.8752 2.40521 15.1787 2.53075 15.4023 2.7546C15.6736 3.0259 15.9741 3.32638 16.2454 3.59768C16.4692 3.82127 16.5948 4.12475 16.5948 4.44074C16.5948 4.75706 16.4692 5.0605 16.2454 5.28408C15.9374 5.59205 15.6632 5.86629 15.6632 5.86629C15.9997 6.4354 16.2597 7.05516 16.429 7.71133H17.2509C17.9094 7.71133 18.4434 8.24526 18.4434 8.90377V10.0962C18.4434 10.7547 17.9094 11.2887 17.2509 11.2887H16.429C16.2597 11.9448 15.9997 12.5646 15.6632 13.1337C15.6632 13.1337 15.9374 13.408 16.2454 13.7159C16.4692 13.9395 16.5948 14.243 16.5948 14.5593C16.5948 14.8753 16.4692 15.1787 16.2454 15.4023C15.9741 15.6736 15.6736 15.9741 15.4023 16.2454C15.1787 16.4693 14.8752 16.5948 14.5593 16.5948C14.2429 16.5948 13.9395 16.4693 13.7159 16.2454C13.4079 15.9374 13.1337 15.6632 13.1337 15.6632C12.5646 15.9997 11.9448 16.2597 11.2887 16.429V17.2509C11.2887 17.9094 10.7547 18.4434 10.0962 18.4434H8.90376C8.24522 18.4434 7.71133 17.9094 7.71133 17.2509V16.429C7.0552 16.2597 6.4354 15.9997 5.86629 15.6632C5.86629 15.6632 5.59205 15.9374 5.28408 16.2454C5.06049 16.4693 4.75701 16.5948 4.44073 16.5948C4.12474 16.5948 3.82123 16.4693 3.59768 16.2454C3.32641 15.9741 3.0259 15.6736 2.75459 15.4023C2.53075 15.1787 2.40521 14.8753 2.40521 14.5593C2.40521 14.243 2.53075 13.9395 2.75459 13.7159C3.06256 13.408 3.33684 13.1337 3.33684 13.1337C3.00026 12.5646 2.74034 11.9448 2.57097 11.2887H1.74911C1.09057 11.2887 0.556641 10.7547 0.556641 10.0962V8.90377C0.556641 8.24526 1.09057 7.71133 1.74911 7.71133H2.57097C2.74034 7.05516 3.00026 6.4354 3.33684 5.86629C3.33684 5.86629 3.06256 5.59205 2.75459 5.28408C2.53075 5.0605 2.40521 4.75706 2.40521 4.44074C2.40521 4.12475 2.53075 3.82127 2.75459 3.59768C3.0259 3.32638 3.32641 3.0259 3.59768 2.7546C3.82123 2.53075 4.12474 2.40521 4.44073 2.40521C4.75701 2.40521 5.06049 2.53075 5.28408 2.7546C5.59205 3.06257 5.86629 3.33684 5.86629 3.33684C6.4354 3.00026 7.0552 2.74031 7.71133 2.57098V1.74908C7.71133 1.09054 8.24522 0.556646 8.90376 0.556646H10.0962C10.7547 0.556646 11.2887 1.09054 11.2887 1.74908V2.57098Z'
          stroke='black'
          strokeWidth='1.5'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.49995 5.92246C11.4744 5.92246 13.0773 7.5254 13.0773 9.49981C13.0773 11.4742 11.4744 13.0771 9.49995 13.0771C7.52555 13.0771 5.92261 11.4742 5.92261 9.49981C5.92261 7.5254 7.52555 5.92246 9.49995 5.92246Z'
          stroke='black'
          strokeWidth='1.5'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
export const IconUser = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={19}
      viewBox='0 0 19 19'
      fill={active ? '#1E42C0' : 'none'}
    >
      <g clipPath='url(#clip0_3639_8376)'>
        <path
          d='M16.2175 2.78248C14.4232 0.988182 12.0375 0 9.5 0C6.9625 0 4.57677 0.988182 2.78248 2.78248C0.988182 4.57677 0 6.9625 0 9.5C0 12.0375 0.988182 14.4232 2.78248 16.2175C4.57677 18.0118 6.9625 19 9.5 19C12.0375 19 14.4232 18.0118 16.2175 16.2175C18.0118 14.4232 19 12.0375 19 9.5C19 6.9625 18.0118 4.57677 16.2175 2.78248ZM4.12305 15.9309C4.43674 13.2318 6.75739 11.1479 9.5 11.1479C10.9458 11.1479 12.3054 11.7112 13.3281 12.7337C14.192 13.5978 14.7369 14.726 14.8771 15.9308C13.4203 17.1509 11.5445 17.8867 9.5 17.8867C7.45551 17.8867 5.57989 17.1511 4.12305 15.9309ZM9.5 10.0013C7.90908 10.0013 6.6146 8.70679 6.6146 7.11587C6.6146 5.5248 7.90908 4.23047 9.5 4.23047C11.0909 4.23047 12.3854 5.5248 12.3854 7.11587C12.3854 8.70679 11.0909 10.0013 9.5 10.0013ZM15.8353 14.9897C15.5516 13.846 14.96 12.7914 14.1152 11.9466C13.431 11.2624 12.6215 10.7491 11.7387 10.4274C12.8 9.70773 13.4987 8.49181 13.4987 7.11587C13.4987 4.91105 11.7048 3.11719 9.5 3.11719C7.29518 3.11719 5.50132 4.91105 5.50132 7.11587C5.50132 8.49254 6.2006 9.70889 7.26271 10.4285C6.45051 10.7245 5.6989 11.1821 5.05224 11.7845C4.11581 12.6566 3.46552 13.7686 3.16401 14.9889C1.88707 13.5168 1.11328 11.5971 1.11328 9.5C1.11328 4.87553 4.87553 1.11328 9.5 1.11328C14.1245 1.11328 17.8867 4.87553 17.8867 9.5C17.8867 11.5975 17.1126 13.5177 15.8353 14.9897Z'
          fill={active ? 'white' : 'black'}
        />
      </g>
      <defs>
        <clipPath id='clip0_3639_8376'>
          <rect width={19} height={19} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export const Location = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={21}
      viewBox='0 0 16 21'
      fill={active ? 'white' : 'black'}
    >
      <path
        d='M8.01869 1.21729C4.1485 1.21729 1 4.36579 1 8.23597C1 9.51007 1.5714 10.8804 1.59535 10.9382C1.7799 11.3762 2.14405 12.0566 2.40663 12.4554L7.21897 19.747C7.41591 20.0459 7.70739 20.2173 8.01869 20.2173C8.32999 20.2173 8.62147 20.0459 8.8184 19.7474L13.6312 12.4554C13.8942 12.0566 14.2579 11.3762 14.4424 10.9382C14.4664 10.8808 15.0374 9.51048 15.0374 8.23597C15.0374 4.36579 11.8889 1.21729 8.01869 1.21729ZM13.6811 10.6178C13.5164 11.0104 13.1774 11.6433 12.9417 12.0009L8.12892 19.2929C8.03396 19.437 8.00382 19.437 7.90886 19.2929L3.09611 12.0009C2.86036 11.6433 2.5214 11.01 2.35667 10.6174C2.34965 10.6004 1.82573 9.33914 1.82573 8.23597C1.82573 4.82117 4.60389 2.04301 8.01869 2.04301C11.4335 2.04301 14.2116 4.82117 14.2116 8.23597C14.2116 9.3408 13.6865 10.6054 13.6811 10.6178Z'
        fill={active ? 'white' : 'black'}
        stroke={active ? 'white' : 'black'}
        strokeWidth='0.5'
      />
      <path
        d='M8.01851 4.52028C5.96947 4.52028 4.30273 6.18742 4.30273 8.23605C4.30273 10.2847 5.96947 11.9518 8.01851 11.9518C10.0676 11.9518 11.7343 10.2847 11.7343 8.23605C11.7343 6.18742 10.0676 4.52028 8.01851 4.52028ZM8.01851 11.1261C6.42527 11.1261 5.12846 9.82971 5.12846 8.23605C5.12846 6.6424 6.42527 5.34601 8.01851 5.34601C9.61175 5.34601 10.9086 6.6424 10.9086 8.23605C10.9086 9.82971 9.61175 11.1261 8.01851 11.1261Z'
        fill={active ? 'white' : 'black'}
        stroke={active ? 'white' : 'black'}
        strokeWidth='0.5'
      />
    </svg>
  )
}
export const Coupon = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={22}
      viewBox='0 0 20 22'
      fill={active ? 'white' : 'black'}
    >
      <path
        d='M5.78597 11.3154C7.79264 11.3658 7.79597 14.4542 5.78997 14.5102C3.78331 14.4591 3.78064 11.3721 5.78597 11.3154ZM6.30931 12.9149C6.30864 12.1981 5.27064 12.1953 5.26664 12.9121C5.26931 13.6268 6.30397 13.6296 6.30931 12.9149Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M9.78652 10.3091C7.78052 10.2559 7.78052 7.16746 9.78652 7.11426C11.7932 7.16816 11.7918 10.2545 9.78652 10.3091ZM9.78652 8.16496C9.10452 8.16776 9.10452 9.25696 9.78652 9.25976C10.4685 9.25626 10.4678 8.16916 9.78652 8.16496Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M4.53978 7.40918C4.73511 7.20338 5.05312 7.20268 5.24912 7.40778L11.0424 13.4621C11.2418 13.663 11.2478 13.9955 11.0564 14.2041C10.8611 14.4183 10.5338 14.419 10.3371 14.2062L4.54312 8.15258C4.34645 7.94818 4.34511 7.61568 4.53978 7.40918Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M14.0986 7.68848C14.3746 7.68848 14.5986 7.92368 14.5986 8.21348V9.55958C14.5986 9.84938 14.3746 10.0846 14.0986 10.0846C13.8226 10.0846 13.5986 9.84938 13.5986 9.55958V8.21348C13.5986 7.92368 13.8226 7.68848 14.0986 7.68848Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M14.0986 11.541C14.3746 11.541 14.5986 11.7762 14.5986 12.066V13.4114C14.5986 13.7012 14.3746 13.9364 14.0986 13.9364C13.8226 13.9364 13.5986 13.7012 13.5986 13.4114V12.066C13.5986 11.7762 13.8226 11.541 14.0986 11.541Z'
        fill={active ? 'white' : 'black'}
      />
      <path
        d='M1.08057 9.07775C0.515903 8.75995 0.16457 8.14045 0.166569 7.46775V5.66735C0.167902 4.65585 0.947903 3.83685 1.91124 3.83545H18.0886C19.0519 3.83685 19.8319 4.65585 19.8332 5.66735V7.46635C19.8352 8.13905 19.4839 8.75855 18.9192 9.07635C18.0066 9.58945 17.6626 10.7822 18.1512 11.7405C18.3259 12.0828 18.5932 12.3635 18.9192 12.5469C19.4846 12.8654 19.8359 13.4849 19.8332 14.1583V15.9573C19.8319 16.9689 19.0519 17.7878 18.0886 17.7892H1.91124C0.947903 17.7878 0.167902 16.9689 0.166569 15.9573V14.1583C0.16457 13.4856 0.515903 12.8661 1.08057 12.5483C2.3899 11.8602 2.3799 9.76585 1.08057 9.07775ZM2.72724 12.2361C2.4599 12.7604 2.05057 13.1902 1.55124 13.4709C1.3119 13.6067 1.1639 13.8699 1.16657 14.1555V15.9545C1.16724 16.3864 1.4999 16.7357 1.91124 16.7364H13.5999C13.6272 16.2814 13.4279 15.4107 14.0999 15.3932C14.7726 15.41 14.5726 16.2849 14.5999 16.7392H18.0886C18.4999 16.7385 18.8326 16.3892 18.8332 15.9573V14.1583C18.8359 13.8727 18.6879 13.6095 18.4486 13.4737C17.0492 12.6869 16.5232 10.8578 17.2726 9.38855C17.5399 8.86425 17.9492 8.43445 18.4486 8.15375C18.6879 8.01795 18.8359 7.75475 18.8332 7.46915V5.66735C18.8326 5.23545 18.4999 4.88615 18.0886 4.88545H14.5999C14.5726 5.34115 14.7732 6.21405 14.0999 6.23155C13.4272 6.21475 13.6272 5.33975 13.5999 4.88545H1.91124C1.4999 4.88615 1.16724 5.23545 1.16657 5.66735V7.46635C1.1639 7.75195 1.3119 8.01515 1.55124 8.15095C2.95057 8.93775 3.47724 10.7668 2.72724 12.2361Z'
        fill={active ? 'white' : 'black'}
      />
    </svg>
  )
}
export const IconNotification = ({ active }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={19}
      height={20}
      viewBox='0 0 19 20'
      fill={active ? 'white' : 'black'}
    >
      <path
        d='M16.6667 13.7044L15.6514 12.2438C15.5128 12.0452 15.4382 11.809 15.4376 11.5669V7.375C15.4376 5.80028 14.812 4.29005 13.6985 3.17655C12.585 2.06306 11.0748 1.4375 9.5001 1.4375C7.92538 1.4375 6.41515 2.06306 5.30165 3.17655C4.18816 4.29005 3.5626 5.80028 3.5626 7.375V11.5669C3.56203 11.809 3.48744 12.0452 3.34885 12.2438L2.33354 13.7044C2.1798 13.8747 2.07871 14.0859 2.04248 14.3125C2.00626 14.5391 2.03645 14.7713 2.1294 14.9811C2.22236 15.1909 2.3741 15.3692 2.56628 15.4946C2.75845 15.62 2.98284 15.687 3.21229 15.6875H6.59073C6.727 16.3586 7.0911 16.962 7.62132 17.3953C8.15155 17.8287 8.8153 18.0655 9.5001 18.0655C10.1849 18.0655 10.8487 17.8287 11.3789 17.3953C11.9091 16.962 12.2732 16.3586 12.4095 15.6875H15.7879C16.0174 15.687 16.2417 15.62 16.4339 15.4946C16.6261 15.3692 16.7778 15.1909 16.8708 14.9811C16.9638 14.7713 16.9939 14.5391 16.9577 14.3125C16.9215 14.0859 16.8204 13.8747 16.6667 13.7044ZM9.5001 16.875C9.1326 16.874 8.77442 16.7593 8.47466 16.5467C8.17489 16.3341 7.94822 16.034 7.82573 15.6875H11.1745C11.052 16.034 10.8253 16.3341 10.5255 16.5467C10.2258 16.7593 9.8676 16.874 9.5001 16.875ZM3.21229 14.5C3.23912 14.4751 3.26303 14.4472 3.28354 14.4169L4.3226 12.9206C4.59979 12.5235 4.74895 12.0512 4.7501 11.5669V7.375C4.7501 6.11522 5.25055 4.90704 6.14134 4.01624C7.03214 3.12545 8.24032 2.625 9.5001 2.625C10.7599 2.625 11.9681 3.12545 12.8589 4.01624C13.7497 4.90704 14.2501 6.11522 14.2501 7.375V11.5669C14.2512 12.0512 14.4004 12.5235 14.6776 12.9206L15.7167 14.4169C15.7372 14.4472 15.7611 14.4751 15.7879 14.5H3.21229Z'
        fill={active ? 'white' : 'black'}
      />
    </svg>
  )
}

export const IconCheckedSuccess = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={27}
      height={27}
      viewBox='0 0 27 27'
      fill='none'
    >
      <circle cx='13.5' cy='13.5' r='13.5' fill='#00E9A1' />
      <path
        d='M11.8129 18.5629C11.3809 18.5629 10.9489 18.3975 10.6199 18.0685L7.24486 14.6935C6.58505 14.0337 6.58505 12.9672 7.24486 12.3074C7.90467 11.6475 8.97117 11.6475 9.63098 12.3074L11.8129 14.4893L17.3699 8.93236C18.0297 8.27255 19.0962 8.27255 19.756 8.93236C20.4158 9.59217 20.4158 10.6587 19.756 11.3185L13.006 18.0685C12.6769 18.3975 12.2449 18.5629 11.8129 18.5629Z'
        fill='white'
      />
    </svg>
  )
}
export const IconCalendar = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={17}
      height={16}
      viewBox='0 0 17 16'
      fill='none'
    >
      <g clipPath='url(#clip0_1526_8641)'>
        <path
          d='M14.5747 3H13.5747V1C13.5747 0.734784 13.4693 0.48043 13.2818 0.292893C13.0943 0.105357 12.8399 0 12.5747 0C12.3095 0 12.0551 0.105357 11.8676 0.292893C11.6801 0.48043 11.5747 0.734784 11.5747 1V3H5.57471V1C5.57471 0.734784 5.46935 0.48043 5.28181 0.292893C5.09428 0.105357 4.83992 0 4.57471 0C4.30949 0 4.05514 0.105357 3.8676 0.292893C3.68006 0.48043 3.57471 0.734784 3.57471 1V3H2.57471C2.04427 3 1.53557 3.21071 1.16049 3.58579C0.785421 3.96086 0.574707 4.46957 0.574707 5L0.574707 14C0.574707 14.5304 0.785421 15.0391 1.16049 15.4142C1.53557 15.7893 2.04427 16 2.57471 16H14.5747C15.1051 16 15.6138 15.7893 15.9889 15.4142C16.364 15.0391 16.5747 14.5304 16.5747 14V5C16.5747 4.46957 16.364 3.96086 15.9889 3.58579C15.6138 3.21071 15.1051 3 14.5747 3ZM2.57471 14V7H14.5747V14H2.57471Z'
          fill='#303538'
        />
      </g>
      <defs>
        <clipPath id='clip0_1526_8641'>
          <rect
            width={16}
            height={16}
            fill='white'
            transform='translate(0.574707)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
